export const translation = {
  zenit: {
    ae: {
      title: 'الرهان على الرياضات على الإنترنت عبر وكيل المراهنات Zenit- أندرويد',
      titlePlay: 'العب باستمرار',
      subTitle: 'كل الأحداث الرياضية في تطبيق واحد',
      button: 'التنزيل ',
      instruction: 'تعليمات التثبيت',
      contentTitle: 'بث مباشر \n' +
        ' لأفضل الأحداث',
      smartphone: 'الآن يمكنك استخدام هاتفك الذكي للوصول',
      navTitle: 'تصفح سهل',
      navText: 'مع واجهة سهلة الاستخدام',
      playTitle: 'ضع رهانًا تراكمي \n' +
        '  ببضع نقرات',
      playText: 'تفقد سجل مراهنتك، أودع واربح',
      instructionTitle: 'Android دليل التثبيت ',
      instructionTitleIos: 'iOS دليل التثبيت',
      footerLink: ' جاهز لمساعدتك ',
      footerText1: 'يمكنك الاتصال ',
      footerText2: ' إذا كان لديك أية أسئلة عن تثبيت التطبيق أو استخدامه،',
      modalTitle: 'Android كيف أحصل على التطبيق',
      modalTitleIos: 'iOS كيف أحصل على التطبيق',
      modalText: 'نعتذر، خدمات متجر ألعاب جوجل غير متاحة لوكلاء المراهنة. نوفر 3 طرق لتنزيل تطبيقنا. يمكنك تثبيته باتباع ',
      modalTextLink: ' التعليمات البسيطة',
      modalWay1: ' الطريقة رقم 1',
      modalWay2: ' الطريقة رقم 2',
      modalWay1Link: 'نزل التطبيق وانقله لجوالك أو افتح هذه الصفحة من هاتفك',
      modalWay1Button: 'تنزيل الملف',
      modalWay1ButtonSpan: 'التطبيقات',
      modalWay2Link: 'افتح رابط التنزيل المباشر على هاتفك بمسح رمز الاستجابة السريع (QR) ضوئيًا',
      stepText0: ' اذهب إلى الإعدادات\n' +
        ' وانقر ملفك الشخصي.',
      stepText1: ' اذهب إلى الوسائط أو المشتريات أو متجر آي تونز ومتجر أبل.',
      stepText2: ' انقر هوية أبل خاصتك.',
      stepText3: ' اختر عرض هوية أبل',
      stepText4: ' اختر البلد/ المنطقة.',
      stepText5: ' اختر الهند.',
      stepText6: ' انقر موافق أو تم في الركن الأيمن العلوي.',
      stepText7: 'وافق على شروط وأحكام اتفاقية المستخدم.',
      stepText8: ' املأ الحقول كما في الصورة (باستثناء الاسم الأول واللقب) .',
      stepText9: ' افتح متجر أبل، واعثر على تطبيق Zenit Bet وثبته.',
      stepText10First: 'إذا وقع خطأ ما، أنشئ حسابًا جديدًا على ',
      stepText10Second: ' واختر الهند في حقل البلد/ المنطقة.',
      stepText10Link: ' الموقع ',
      stepText11First: 'عد إلى الخطوة 4 ',
      stepText11Second: '  واختر خروج.',
      stepText12First: 'سجل الدخول إلى حسابك الجديد،  ',
      stepText12Second: ' اذهب للخطوة 9.',
      step1: ' 1 الخطوة ' ,
      step2: ' 2 الخطوة ' ,
      step3: ' 3 الخطوة ' ,
      step4: ' 4 الخطوة ' ,
      step5: ' 5 الخطوة ' ,
      step6: ' 6 الخطوة ' ,
      step7: ' 7 الخطوة ' ,
      step8: ' 8 الخطوة ' ,
      step9: ' 9 الخطوة ' ,
      step10: ' 10 الخطوة ',
      step11: ' 11 الخطوة ',
      step12: ' 12 الخطوة ',
      step13: ' 13 الخطوة ',
      stepTextAndroid1: ' انقر موافق \n' +
        'ونزّل الملف بامتداد APK.',
      stepTextAndroid2: 'افتح الملف بامتداد APK الذي نزلته. ',
      stepTextAndroid3: ' اختر سماح من هذا المصدر. ',
      stepTextAndroid4: ' بعد فتح ملف التثبيت، اختر الإعدادات.',
      stepTextAndroid5: 'في الشاشة التالية، اختر تثبيت.',
    },
    bn: {
      title: 'অ্যান্ড্রয়েড - বুকমেকার Zenit অনলাইন স্পোর্টস বাজি',
      titlePlay: 'চলতে চলতে খেলুন!',
      subTitle: 'একটিমাত্র অ্যাপে ক্রীড়ার সমস্ত ইভেন্ট',
      button: 'জন্য ডাউনলোড করুন',
      instruction: 'ইনস্টলেশনের নির্দেশাবলী',
      contentTitle: 'শীর্ষ ইভেন্টগুলোর সরাসরি সম্প্রচার',
      smartphone: 'এখন আপনি আপনার স্মার্টফোনটি ব্যবহার করে অ্যাক্সেস করতে পারেন',
      navTitle: 'দ্রুত ন্যাভিগেশন',
      navText: 'সহজেই ব্যবহারযোগ্য ইন্টারফেসের সঙ্গে',
      playTitle: 'কয়েক ক্লিকে একটি অ্যাকুমুলেটর রাখুন',
      playText: 'আপনার বাজি ধরার ইতিহাস দেখুন, জমা দিন এবং জিতুন!',
      instructionTitle: 'Android-এর জন্য ইনস্টলেশন গাইড',
      instructionTitleIos: 'iOS-এর জন্য ইনস্টলেশন গাইড',
      footerLink: ' আপনাকে সাহায্য করতে প্রস্তুত ',
      footerText1: 'অ্যাপ ইনস্টল বা ব্যবহার সম্পর্কে আপনার যদি কোনও প্রশ্ন থাকে, ',
      footerText2: '  আপনি যোগাযোগ করতে পারেন',
      modalTitle: 'আমি কিভাবে Android-এর জন্য অ্যাপটি পাব',
      modalTitleIos: 'আমি কিভাবে iOS-এর জন্য অ্যাপটি পাব',
      modalText: 'আমরা দুঃখিত, Google Play সার্ভিস বুকমেকার-এর জন্য পাওয়া যাবে না। আমরা আমাদের অ্যাপটি ডাউনলোড করার জন্য 3 টি পদ্ধতি অফার করছি। আপনি এই সহজ নির্দেশাবলীগুলো অনুসরণ করে ',
      modalTextLink: ' এটি ইনস্টল করতে পারেন।',
      modalWay1: 'পদ্ধতি 1',
      modalWay2: 'পদ্ধতি 2',
      modalWay1Link: 'অ্যাপটি ডাউনলোড করুন এবং আপনার মোবাইল ফোনে ট্রান্সফার করুন বা আপনার ফোন থেকে এই পেজটি খুলুন',
      modalWay1Button: 'ডাউনলোড ফাইল',
      modalWay1ButtonSpan: 'অ্যাপগুলি',
      modalWay2Link: 'QR কোডটি স্ক্যান করে আপনার ফোনে সরাসরি ডাউনলোড লিঙ্কটি খুলুন',
      stepText0: ' সেটিংস-এ যান এবং আপনার প্রোফাইলটি আলতো চাপুন',
      stepText1: 'মিডিয়া এবং ক্রয়-এ যান অথবা iTunes স্টোর এবং অ্যাপ স্টোরে যান',
      stepText2: 'আপনার Apple আইডি আলতো চাপুন',
      stepText3: ' Apple আইডি দেখুন নির্বাচন করুন',
      stepText4: 'দেশ/অঞ্চল নির্বাচন করুন',
      stepText5: ' ভারত নির্বাচন করুন',
      stepText6: ' উপরের ডান কোণায় থাকা স্বীকার করুন বা সম্পন্ন হয়েছে আলতো চাপুন',
      stepText7: 'ব্যবহারকারীর চুক্তির শর্তাবলী স্বীকার করুন',
      stepText8: ' ছবিতে দেখানো ঘরগুলো পূরণ করুন (নামের প্রথম অংশ এবং শেষ অংশ বাদে)',
      stepText9: ' অ্যাপ স্টোর খুলুন, Zenit Bet অ্যাপটি খুঁজুন এবং এটি ইন্সটল করুন',
      stepText10First: ' যদি কোনো ত্রুটি ঘটে থাকে, তাহলে ',
      stepText10Second: ' একটি নতুন অ্যাকাউন্ট তৈরি করুন এবং দেশ/অঞ্চলের ক্ষেত্রে ভারত নির্বাচন করুন',
      stepText10Link: ' ওয়েবসাইটে ',
        stepText11First: 'ধাপ 4 এ ফিরে যান  ',
      stepText11Second: ' এবং প্রস্থান নির্বাচন করুন',
      stepText12First: 'আপনার নতুন অ্যাকাউন্টে সাইন ইন করুন, ',
      stepText12Second: ' ধাপ 9-এ যান',
      step1: 'ধাপ 1',
      step2: 'ধাপ 2',
      step3: 'ধাপ 3',
      step4: 'ধাপ 4',
      step5: 'ধাপ 5',
      step6: 'ধাপ 6',
      step7: 'ধাপ 7',
      step8: 'ধাপ 8',
      step9: 'ধাপ 9',
      step10: 'ধাপ 10',
      step11: 'ধাপ 11',
      step12: 'ধাপ 12',
      step13: 'ধাপ 13',
      stepTextAndroid1: 'ঠঠিক আছে আলতো চাপুন \n' +
        'এবং APK ফাইলটি ডাউনলোড করুন।',
      stepTextAndroid2: 'ডাউনলোড করা APK ফাইলটি খুলুন ',
      stepTextAndroid3: 'ইনস্টলেশন ফাইল খোলার পরে, সেটিংস নির্বাচন করুন ',
      stepTextAndroid4: 'এই উৎসের বাক্স থেকে অ্যালাউ চেক করুন',
      stepTextAndroid5: 'খোলা উইন্ডোতে ইনস্টল ক্লিক করুন',
    },
    br: {
      title: 'Android - Zenit Apostas Esportivas Online',
      titlePlay: 'Jogue no celular!',
      subTitle: 'Todos os eventos esportivos em um aplicativo',
      button: 'BAIXE PARA',
      instruction: 'Instruções de instalação',
      contentTitle: 'Transmissões ao vivo\n' +
        'dos principais eventos',
      smartphone: 'Agora você pode usar o seu smartphone para acessar',
      navTitle: 'Navegação rápida',
      navText: 'Com uma interface fácil de usar',
      playTitle: 'Efetue uma aposta acumuladora\n' +
        'com apenas alguns cliques',
      playText: 'Consulte o seu histórico de apostas, faça depósitos e ganhe!',
      instructionTitle: 'Guia de instalação para Android',
      instructionTitleIos: 'Guia de instalação para iOS',
      footerLink: '  equipe de suporte  ',
      footerText1: 'Se você tiver alguma dúvida sobre como instalar ou usar o aplicativo, nossa ',
      footerText2: ' está aqui para ajudar',
      modalTitle: 'Como obter o aplicativo para Android?',
      modalTitleIos: 'Como obter o aplicativo para iOS',
      modalText: 'Lamentamos, mas o serviços do Google Play não estão disponíveis para apostadores. Oferecemos dois métodos alternativos para baixar nosso aplicativo. Siga as ',
      modalTextLink: ' instruções simples de instalação abaixo',
      modalWay1: 'Método 1',
      modalWay2: 'Método 2',
      modalWay1Link: 'Baixe o app e transfira-o para seu celular ou abra esta página no seu telefone',
      modalWay1Button: 'BAIXE O ARQUIVO DE ',
      modalWay1ButtonSpan: 'INSTALAÇÃO',
      modalWay2Link: 'Abra o link de download diretamente no seu telefone, escaneando o código QR',
      stepText0: ' Vá para Configurações e toque no seu perfil',
      stepText1: ' Vá para Mídia e Compras ou para a Loja iTunes e App Store',
      stepText2: ' Toque na ID Apple',
      stepText3: 'Selecione Ver ID Apple',
      stepText4: 'Selecione país/região',
      stepText5: 'Selecione Índia',
      stepText6: 'Toque em Aceitar ou OK no canto superior direito',
      stepText7: 'Aceite os Termos e Condições do Acordo de Usuário',
      stepText8: 'Preencha os campos conforme exibido na imagem (exceto para Nome e Sobrenome)',
      stepText9: ' Abra a App Store, localize o app Zenit Bet e instale',
      stepText10First: ' Se um erro ocorreu, crie uma nova conta no ',
      stepText10Second: ' selecione Índia no campo país/região',
      stepText10Link: ' site  ',
      stepText11First: 'Volte ao PASSO 4 ',
      stepText11Second: ' e selecione Sair',
      stepText12First: 'Faça login na nova conta ',
      stepText12Second: ' e vá para o PASSO 9',
      step1: 'PASSO 1',
      step2: 'PASSO 2',
      step3: 'PASSO 3',
      step4: 'PASSO 4',
      step5: 'PASSO 5',
      step6: 'PASSO 6',
      step7: 'PASSO 7',
      step8: 'PASSO 8',
      step9: 'PASSO 9',
      step10: 'PASSO 10',
      step11: 'PASSO 11',
      step12: 'PASSO 12',
      step13: 'PASSO 13',
      stepTextAndroid1: ' Toque em OK e baixe o arquivo APK',
      stepTextAndroid2: 'Abra o arquivo APK baixado',
      stepTextAndroid3: 'Após abrir o arquivo de instalação, selecione Configurações',
      stepTextAndroid4: 'Marque a opção Permitir desta caixa de fonte',
      stepTextAndroid5: 'Clique em Instalar na janela aberta',
    },
    de: {
      title: 'Android – Buchmacher Zenit Online-Sportwetten',
      titlePlay: 'Spielen von unterwegs!',
      subTitle: 'Alle Sportereignisse in einer App',
      button: 'HERUNTERLADEN FÜR',
      instruction: 'Installationsanleitung',
      contentTitle: 'Live-Übertragung von Top-Ereignissen',
      smartphone: 'Jetzt können Sie mit Ihrem Smartphone auf',
      navTitle: 'Schnelle Navigation',
      navText: 'Mit einer einfach zu bedienenden Oberfläche',
      playTitle: 'Platzieren eines Akkumulators mit nur wenigen Mausklicks',
      playText: 'Überprüfen Sie Ihre Wetthistorie, tätigen Sie Einzahlungen und gewinnen Sie!',
      instructionTitle: 'Installationsanleitung für Android',
      instructionTitleIos: 'Installationsanleitung für iOS',
      footerLink: ' unser Support-Team ',
      footerText1: 'Wenn Sie Fragen zur Installation oder Verwendung der App haben, steht Ihnen ',
      footerText2: ' zur Verfügung',
      modalTitle: 'Wie bekomme ich die App für Android',
      modalTitleIos: 'Wie bekomme ich die App für iOS',
      modalText: 'Es tut uns leid, die Dienste von Google Play sind für Buchmacher nicht verfügbar. Wir bieten 2 Methoden an, um unsere App herunterzuladen. Sie können sie installieren, indem Sie die',
      modalTextLink: ' einfachen Anweisungen befolgen.',
      modalWay1: 'Methode 1',
      modalWay2: 'Methode 2',
      modalWay1Link: 'Laden Sie die App herunter und übertragen Sie sie auf Ihr Mobiltelefon oder öffnen Sie diese Seite von Ihrem Telefon aus',
      modalWay1Button: 'DATEI HERUNTERLADEN',
      modalWay1ButtonSpan: 'APPS',
      modalWay2Link: 'Öffnen Sie den Link für den direkten Download auf Ihrem Telefon durch Scannen des QR-Codes',
      stepText0: ' Gehen Sie zu "Einstellungen" und tippen Sie auf Ihr Profil',
      stepText1: 'Gehen Sie zu "Medien und Einkäufe" oder zum iTunes Store und App Store',
      stepText2: 'Tippen Sie auf Ihre Apple ID',
      stepText3: ' Wählen Sie Apple ID anzeigen',
      stepText4: ' Wählen Sie Land/Region aus',
      stepText5: ' Wählen Sie Indien aus',
      stepText6: 'Tippen Sie oben rechts auf "Akzeptieren" oder "Fertig"',
      stepText7: 'Bedingungen der allgemeinen Geschäftsbedingungen akzeptieren',
      stepText8: 'Füllen Sie die Felder aus, die auf dem Foto zu sehen sind (außer Vor- und Nachname)',
      stepText9: 'Öffnen Sie den App Store, suchen Sie die Zenit Bet-App und installieren Sie sie',
      stepText10First: 'Wenn ein Fehler aufgetreten ist, erstellen Sie ein neues Konto auf der ',
      stepText10Second: ' und wählen Sie "Indien" im Feld "Land/Region"',
      stepText10Link: ' Webseite  ',
      stepText11First: ' Gehen Sie zurück zu SCHRITT 4 ',
      stepText11Second: ' und wählen Sie "Beenden”',
      stepText12First: ' Melden Sie sich bei Ihrem neuen Konto an  ',
      stepText12Second: ' und gehen Sie zu Schritt 9',
      step1: 'Schritt 1',
      step2: 'Schritt 2',
      step3: 'Schritt 3',
      step4: 'Schritt 4',
      step5: 'Schritt 5',
      step6: 'Schritt 6',
      step7: 'Schritt 7',
      step8: 'Schritt 8',
      step9: 'Schritt 9',
      step10: 'Schritt 10',
      step11: 'Schritt 11',
      step12: 'Schritt 12',
      step13: 'Schritt 13',
      stepTextAndroid1: 'Tippen Sie auf OK \n' +
        ' und laden Sie die APK-Datei herunter',
      stepTextAndroid2: 'Öffnen Sie die heruntergeladene APK-Datei ',
      stepTextAndroid3: 'Nachdem Sie die Installationsdatei geöffnet haben, wählen Sie "Einstellungen". ',
      stepTextAndroid4: 'Aktivieren Sie die Option "Von dieser Quelle zulassen"',
      stepTextAndroid5: 'Klicken Sie im sich geöffneten Fenster auf "Installieren"',
    },
    en: {
      title: 'Android - Bookmaker Zenit online sports betting',
      titlePlay: 'Play on the go!',
      subTitle: 'Play on the go!',
      button: 'DOWNLOAD FOR',
      instruction: 'Installation instructions',
      contentTitle: 'Live broadcasts of top events',
      smartphone: 'Now you can use your smartphone to access',
      navTitle: 'Fast navigation',
      navText: 'With an easy-to-use interface',
      playTitle: 'Place an accumulator in a few clicks',
      playText: 'Check your betting history, make deposits and win!',
      instructionTitle: 'Installation guide for Android',
      instructionTitleIos: 'Installation instructions on iOS',
      footerLink: ' our support team ',
      footerText1: 'If you have any questions on how to install or use the app, ',
      footerText2: ' is here to help you',
      modalTitle: 'How do I get the app for Android',
      modalTitleIos: 'How do I get the app for iOS',
      modalText: 'We are sorry, Google Play services are not available to bookmakers. We offer two methods to download our app. You can install it by following the ',
      modalTextLink: ' simple instructions',
      modalWay1: 'Method 1',
      modalWay2: 'Method 2',
      modalWay1Link: 'Download the app and transfer it to your mobile phone or open this page over your phone',
      modalWay1Button: 'DOWNLOAD THE ',
      modalWay1ButtonSpan: 'SETUP FILE',
      modalWay2Link: 'Open the direct download link on your phone by scanning the QR code',
      stepText0: 'Go to Settings and click on your profile',
      stepText1: 'Go to item “Media and Purchases” or “iTunes and App Store”',
      stepText2: 'Click on your Apple ID',
      stepText3: 'Go to “View Apple ID ”',
      stepText4: 'Go to "Country or region"',
      stepText5: 'Choose the country "India"',
      stepText6: 'Click “Accept” or “Done” on the top right',
      stepText7: 'Accept the terms of the user agreement',
      stepText8: 'Fill in the fields as indicated in the photo (except for the name and surname)',
      stepText9: 'Open the App Store, find Zenit Bet and install it',
      stepText10First: 'If you receive an error, then you need to create a new account on  ',
      stepText10Second: ', specify India as the country',
      stepText10Link: ' the site ',
      stepText11First: 'Go back to step 4 ',
      stepText11Second: ' and choose "Exit"',
      stepText12First: 'Log in with a new account, ',
      stepText12Second: ' go to step 9',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
      step4: 'Step 4',
      step5: 'Step 5',
      step6: 'Step 6',
      step7: 'Step 7',
      step8: 'Step 8',
      step9: 'Step 9',
      step10: 'Step 10',
      step11: 'Step 11',
      step12: 'Step 12',
      step13: 'Step 13',
      stepTextAndroid1: 'Press the button OK and save .apk file.',
      stepTextAndroid2: 'Open the downloaded .apk file.',
      stepTextAndroid3: 'After opening the installation file, select the "Settings" button.',
      stepTextAndroid4: 'Check the box "Allow installation from this source."',
      stepTextAndroid5: 'Click “Install” in appeared window',
    },
    fr: {
      title: 'Android - Bookmaker Zenit paris sportifs en ligne',
      titlePlay: 'Jouez quand vous êtes en déplacement!',
      subTitle: 'Tous les événements sportifs dans une seule application',
      button: 'TÉLÉCHARGEMENT POUR',
      instruction: 'Instructions d\'installation',
      contentTitle: 'Diffusions en direct des principaux événements',
      smartphone: 'Vous pouvez désormais utiliser votre smartphone pour accéder',
      navTitle: 'Navigation rapide',
      navText: 'Avec une interface facile à utiliser',
      playTitle: 'PLACEZ UN ACCUMULATEUR EN QUELQUES CLICS',
      playText: 'Consultez l\'historique de vos paris, effectuez des dépôts et gagnez!',
      instructionTitle: 'Guide d\'installation pour Android',
      instructionTitleIos: 'Guide d\'installation pour iOS',
      footerLink: '  notre équipe d\'assistance ',
      footerText1: 'Pour toute question sur la manière d\'installer ou d\'utiliser l\'application,  ',
      footerText2: ' est prête à vous aider',
      modalTitle: 'Comment obtenir l\'application pour Android',
      modalTitleIos: 'Comment obtenir l\'application pour iOS',
      modalText: 'Nous sommes désolés, les services de Google Play ne sont pas disponibles pour les bookmakers. Nous proposons 2 méthodes pour télécharger notre application. Vous pouvez l\'installer en suivant ',
      modalTextLink: ' ces instructions simples.',
      modalWay1: 'Méthode 1',
      modalWay2: 'Méthode 2',
      modalWay1Link: 'Téléchargez l\'application et transférez-la sur votre téléphone portable, ou ouvrez cette page depuis votre téléphone',
      modalWay1Button: 'TÉLÉCHARGER LE FICHIER',
      modalWay1ButtonSpan: 'APPLICATIONS',
      modalWay2Link: 'Ouvrez le lien de téléchargement direct sur votre téléphone en scannant le code QR',
      stepText0: 'Allez à Paramètres et appuyez sur votre profile',
      stepText1: ' Allez à Média et Achats ou dans iTunes Store et App Store',
      stepText2: 'Appuyez sur votre identifiant Apple',
      stepText3: 'Sélectionnez Afficher l\'identifiant Apple',
      stepText4: 'Sélectionnez Pays/Région',
      stepText5: 'Sélectionnez Inde',
      stepText6: 'Appuyez sur Accepter ou Terminé dans le coin supérieur droit',
      stepText7: ' Acceptez les Conditions générales du Contrat d\'utilisateur',
      stepText8: 'Renseignez les champs comme illustré sur la photo (sauf pour le prénom et le nom)',
      stepText9: 'Ouvrez l\'App Store, trouvez l\'application Zenit Bet et installez-la',
      stepText10First: 'Si un message d\'erreur s\'affiche, créez un nouveau compte sur ',
      stepText10Second: ' et sélectionnez Inde dans le champ Pays/Région',
      stepText10Link: ' le site Web ',
      stepText11First: 'Revenez à ÉTAPE 4 ',
      stepText11Second: ' et sélectionnez Quitter',
      stepText12First: 'Connectez-vous à votre nouveau compte, ',
      stepText12Second: ' passez à ÉTAPE 9',
      step1: 'Étape 1',
      step2: 'Étape 2',
      step3: 'Étape 3',
      step4: 'Étape 4',
      step5: 'Étape 5',
      step6: 'Étape 6',
      step7: 'Étape 7',
      step8: 'Étape 8',
      step9: 'Étape 9',
      step10: 'Étape 10',
      step11: 'Étape 11',
      step12: 'Étape 12',
      step13: 'Étape 13',
      stepTextAndroid1: 'Appuyez sur OK \n' +
        ' pour télécharger le fichier APK.',
      stepTextAndroid2: 'Ouvrez le fichier APK téléchargé. ',
      stepTextAndroid3: 'Après avoir ouvert le fichier d\'installation, sélectionnez Paramètres ',
      stepTextAndroid4: 'Cochez l\'option Autoriser à partir de cette boîte de base',
      stepTextAndroid5: 'Cliquez sur Installer dans la fenêtre qui s\'est ouverte',
    },
    ir: {
      title: 'اندروید - بنگاه شرط‌بندی آنلاین Zenit برای رویدادهای ورزشی',
      titlePlay: 'بازی در همه حال!',
      subTitle: 'تمام رویدادهای ورزشی در یک برنامه',
      button: 'دانلود برای',
      instruction: 'راهنمای نصب',
      contentTitle: 'پخش زنده\n' +
        'رویدادهای مهم',
      smartphone: 'اکنون می‌توانید برای دسترسی از موبایل خود استفاده کنید',
      navTitle: 'پیمایش سریع',
      navText: 'با رابط کاربری ساده',
      playTitle: 'شرط ترکیبی\n' +
        'فقط با چند کلیک',
      playText: 'بررسی شرط‌های قبلی، واریز وجه، و برد!',
      instructionTitle: 'راهنمای نصب Android',
      instructionTitleIos: 'راهنمای نصب iOS',
      footerLink: '  پشتیبانی ما  ',
      footerText1: 'اگر سوالی در خصوص نحوه‌ی نصب یا استفاده از برنامه دارید، تیم ',
      footerText2: ' آماده راهنمایی شماست.',
      modalTitle: 'برنامه Android را چگونه دریافت کنم',
      modalTitleIos: 'برنامه iOS را چگونه دریافت کنم',
      modalText: ' متأسفانه خدمات گوگل پلی برای بنگاه‌های شرط‌بندی مجاز نیست. دو روش برای دانلود برنامه ما وجود دارد.می‌توانید برنامه را با کمک راهنمایی‌های زیر به راحتی ',
      modalTextLink: ' نصب کنید ',
      modalWay1: 'روش اول',
      modalWay2: 'روش دوم',
      modalWay1Link: 'برنامه را دانلود کنید و آن را به تلفن همراه‌تان منتقل کنید یا اینکه این صفحه را با تلفن همراه‌تان باز کنید.',
      modalWay1Button: 'دانلود فایل ',
      modalWay1ButtonSpan: ' نصب',
      modalWay2Link: 'لینک دانلود مستقیم را با اسکن کردن کد QR با موبایل خود باز کنید',
      stepText0: ' به تنظیمات بروید و روی پروفایل خود بزنید.',
      stepText1: ' به رسانه و خریدها یا فروشگاه iTunes یا اپ استوربروید.',
      stepText2: 'روی اپل آیدی خود بزنید.',
      stepText3: ' گزینه مشاهده پل آیدی را بزنید.',
      stepText4: ' انتخاب کشور/منطقه”',
      stepText5: 'کشور هند را انتخاب کنید',
      stepText6: ' روی گزینه Accept یا Done در بالا سمت راست بزنید',
      stepText7: ' با شرایط و ضوابط توافق‌نامه‌ی کاربر موافقت کنید',
      stepText8: ' جای‌خالی را مشابه تصویر پر کنید (به استثنای نام و نام خانوادگی)',
      stepText9: ' اپ استور را باز کنید، برنامه Zenit Bet را پیدا کرده و روی گزینه نصب بزنید.',
      stepText10First: '  اگر خطایی رخ داد، یک حساب کاربری جدید در ',
      stepText10Second: ' ایجاد کنید و در قسمت کشور/منطقه هند را انتخاب کنید.',
      stepText10Link: '  وب‌سایت ',
      stepText11First: 'به مرحله ۴ مراجعه کنید و خروج',
      stepText11Second: ' یا Exit را انتخاب کنید.',
      stepText12First: 'وارد حساب کاربری جدیدتان شوید و ',
      stepText12Second: '  به مرحله ۹ بروید.',
      step1: 'مرحله ۱',
      step2: 'مرحله ۲',
      step3: 'مرحله ۳',
      step4: 'مرحله ۴',
      step5: 'مرحله ۵',
      step6: 'مرحله ۶',
      step7: 'مرحله ۷ ',
      step8: 'مرحله ۸',
      step9: 'مرحله ۹',
      step10: 'مرحله ۱۰',
      step11: 'مرحله ۱۱',
      step12: 'مرحله ۱۲',
      step13: 'مرحله ۱۳',
      stepTextAndroid1: ' روی OK بزنید\n' +
        ' و فایل APK را دانلود کنید.',
      stepTextAndroid2: 'فایل APK دانلود شده را باز کنید',
      stepTextAndroid3: 'بعد از باز کردن فایل نصبی، «تنظیمات» را انتخاب کنید',
      stepTextAndroid4: 'گزینه‌ی «مجاز از این منبع» را تیک بزنید',
      stepTextAndroid5: 'در پنجره‌ی باز شده روی «نصب» کلیک کنید',
    },
    kz: {
      title: 'Android - Зенит БК спортына онлайн-ұтыстар',
      titlePlay: 'Кез келген уақытта және кез келген жерде ойна!',
      subTitle: 'Спорттың барлық шаралары бір қолданбада',
      button: ' ҮШІН ЖҮКТЕП АЛУ',
      instruction: 'Орнату нұсқаулығы',
      contentTitle: 'Үздік іс-шаралардың тікелей трансляциясы',
      smartphone: 'Енді сенің смартфоныңда',
      navTitle: 'Жылдам навигация',
      navText: 'Іс-шараларды көрсетудің ыңғайлы форматымен',
      playTitle: 'Бар болғаны бірнеше рет басу арқылы экспрестерді жина',
      playText: 'Ұтыстардың тарихын қадағала, шотыңды толтырып, ақша ұт!',
      instructionTitle: 'Android құрылғысына орнату туралы нұсқаулық',
      instructionTitleIos: 'iOS құрылғысына орнату туралы нұсқаулық',
      footerLink: ' қолдау қызметіміз ',
      footerText1: 'Орнату жөнінде немесе қолданба жұмысы бойынша сұрақтар туындаса, біздің ',
      footerText2: ' саған қуана кеңес береді',
      modalTitle: 'Қолданбаны Android құрылғысына қалай алуға болады',
      modalTitleIos: 'Қолданбаны iOS құрылғысына қалай алуға болады',
      modalText: 'Өкінішке орай, букмекерлер үшін Google Play қызметтері қолжетімді емес, сондықтан біз саған екі әдістің кез келгенін пайдаланып біздің қолданы жүктеп алуды және ',
      modalTextLink: ' қарапайым нұсқауларды',
      modalTextKZ: 'орындап орнатуды ұсынамыз.',
      modalWay1: '1-әдіс',
      modalWay2: '2-әдіс',
      modalWay1Link: 'Қолданбаны жүктеп алып, оны өз телефоныңызға жіберіңіз немесе осы бетті телефоннан ашыңыз',
      modalWay1ButtonKZ: 'ҚОЛДАНБА ',
      modalWay1Button: 'ФАЙЛЫН ЖҮКТЕП АЛУ',
      modalWay1ButtonSpan: '',
      modalWay2Link: 'QR кодын сканерлеу арқылы телефоннан жүктеп алу сілтемесін ашыңыз',
      stepText0: 'Параметрлерге өтіп, өз профиліңді таңда',
      stepText1: '“Медиаматериалдар мен сатып алулар” немесе “iTunes Store және App Store” тармағына өт',
      stepText2: 'Өз Apple ID идентифакторыңды бас',
      stepText3: ' “Apple ID қарау” тармағына өт',
      stepText4: '“Ел немесе аймақ” тармағына өт',
      stepText5: '“Үндістан” елін таңда',
      stepText6: ' Жоғарғы оң жақтағы “Қабылдау” немесе “Дайын” түймесін бас',
      stepText7: 'Пайдаланушы келісімінің шарттарын қабылда',
      stepText8: ' Суретте көрсетілгендей өрісті толтыр (аты мен тегінен басқа)',
      stepText9: ' App Store қолданбасын аш, Zenit Bet қолданбасын тап та, оны орнат',
      stepText10First: 'Қате алынса, ',
      stepText10Second: ' жаңа аккаунтты жасау қажет, ел ретінде Үндістанды көрсет',
      stepText10Link: ' сайтта  ',
      stepText11First: '4-қадамға орал да, ',
      stepText11Second: ' “Шығу” параметрін таңда',
      stepText12First: 'Жаңа аккаунтпен авторизациядан өт те, ',
      stepText12Second: ' 9-қадамға өт',
      step1: '1-ҚАДАМ',
      step2: '2-ҚАДАМ',
      step3: '3-ҚАДАМ',
      step4: '4-ҚАДАМ',
      step5: '5-ҚАДАМ',
      step6: '6-ҚАДАМ',
      step7: '7-ҚАДАМ',
      step8: '8-ҚАДАМ',
      step9: '9-ҚАДАМ',
      step10: '1-ҚАДАМ0',
      step11: '1-ҚАДАМ1',
      step12: '1-ҚАДАМ2',
      step13: '1-ҚАДАМ3',
      stepTextAndroid1: ' OK түймесін басып, .apk файлын сақта',
      stepTextAndroid2: 'Жүктеп алынған .apk файлын аш',
      stepTextAndroid3: 'Орнату файлын ашқан соң, «Параметрлер» түймесін таңдаңыз',
      stepTextAndroid4: '«Осы дереккөзден орнатуға рұқсат ету» тармағын белгілеңіз',
      stepTextAndroid5: 'Пайда болған терезеде «Орнату» түймесін басыңыз',
    },
    mx: {
      title: 'Android - apuestas deportivas en línea con Bookmaker Zenit',
      titlePlay: '¡Juegue sobre la marcha!',
      subTitle: 'Todos los eventos deportivos en una aplicación',
      button: 'DESCARGA PARA',
      instruction: 'Instrucciones de instalación',
      contentTitle: 'Transmisión en directo de los principales eventos',
      smartphone: 'Ahora puede usar su smartphone para acceder\u00A0a',
      navTitle: 'Navegación rápida',
      navText: 'Con una interfaz fácil de usar',
      playTitle: 'Coloque un acumulador en unos cuantos clics',
      playText: '¡Revise su historial de apuestas, realice depósitos y gane!',
      instructionTitle: 'Guía de instalación para Android',
      instructionTitleIos: 'Guía de instalación para iOS',
      footerLink: '  de suporte está aqui  ',
      footerText1: 'Se você tiver alguma dúvida sobre como instalar ou usar o aplicativo, nossa equipe ',
      footerText2: ' para ajudar',
      modalTitle: 'Cómo obtengo la aplicación para Android',
      modalTitleIos: 'Cómo obtengo la aplicación para iOS',
      modalText: 'Lo sentimos, los servicios de Google Play no están disponibles para Bookmakers. Ofrecemos 2 métodos para descargar nuestra aplicación. Puede instalarla siguiendo ',
      modalTextLink: ' las instrucciones simples.',
      modalWay1: 'Método 1',
      modalWay2: 'Método 2',
      modalWay1Link: 'Descargue la aplicación y transfiérala a su teléfono móvil o abra esta página desde su teléfono',
      modalWay1Button: 'DESCARGAR ARCHIVO',
      modalWay1ButtonSpan: 'APLICACIONES',
      modalWay2Link: 'Escanee el código QR para abrir el enlace de descarga directa en su teléfono',
      stepText0: 'Vaya a Ajustes y toque en su perfil',
      stepText1: 'Vaya a Media y Compras o a Tienda iTunes Store y Tienda de Aplicaciones',
      stepText2: 'Toque su Apple ID',
      stepText3: ' Seleccione Vista Apple ID',
      stepText4: ' Seleccione país/región',
      stepText5: 'Seleccione India',
      stepText6: 'Toque Aceptar o Hecho en la esquina superior derecha',
      stepText7: 'Acepte los Términos y Condiciones del Acuerdo de Usuario',
      stepText8: ' Complete los campos tal y como se ve en la foto (exepto en Nombre y Apellido)',
      stepText9: 'Abrir la Tienda de Aplicaciones, busque la aplicación Zenit Bet e instálela',
      stepText10First: ' Si ha tenido lugar un error, cree una nueva cuenta en  ',
      stepText10Second: ' y seleccione India en el campo de País/Región',
      stepText10Link: ' el sitio web ',
      stepText11First: 'Regrese al paso 4 ',
      stepText11Second: ' y seleccione Salir',
      stepText12First: 'entre en su nueva cuenta, ',
      stepText12Second: ' vaya al PASO 9',
      step1: 'PASO 1',
      step2: 'PASO 2',
      step3: 'PASO 3',
      step4: 'PASO 4',
      step5: 'PASO 5',
      step6: 'PASO 6',
      step7: 'PASO 7',
      step8: 'PASO 8',
      step9: 'PASO 9',
      step10: 'PASO 10',
      step11: 'PASO 11',
      step12: 'PASO 12',
      step13: 'PASO 13',
      stepTextAndroid1: ' Toque Aceptar y descargue el archivo APK.',
      stepTextAndroid2: 'Abra el archivo APK descargado',
      stepTextAndroid3: 'Después de abrir el enlace o el archivo de instalación, seleccione Configuración.',
      stepTextAndroid4: 'Marque la opción Permitir desde esta fuente',
      stepTextAndroid5: 'Haga clic en Instalar en la ventana abierta',

    },
    ru: {
      title: 'Скачать приложение БК Зенит | Ставки онлайн',
      titlePlay: 'Играй всегда и везде!',
      subTitle: 'Все события спорта в одном приложении',
      button: 'СКАЧАТЬ ДЛЯ',
      instruction: 'Инструкция по установке',
      contentTitle: 'Прямые трансляции топовых событий',
      smartphone: 'Теперь в твоем смартфоне',
      navTitle: 'Быстрая навигация',
      navText: 'C удобными форматами отображения событий',
      playTitle: 'Собирай экспрессы всего за пару кликов',
      playText: 'Следи за историей ставок, пополняй счет и выигрывай!',
      instructionTitle: 'Инструкция по установке на Android',
      instructionTitleIos: 'Инструкция по установке на iOS',
      footerLink: ' наша служба поддержки ',
      footerText1: 'Если у тебя возникли вопросы с установкой или работой приложения, ',
      footerText2: ' с радостью тебя проконсультирует',
      modalTitle: 'Как получить приложение для Android',
      modalTitleIos: 'Как получить приложение для iOS',
      modalText: 'К сожалению, сервисы Google Play недоступны для букмекеров, поэтому мы предлагаем тебе скачать наше ' +
        'приложение любым из двух способов и установить его следуя ',
      modalTextLink: ' простой инструкции',
      modalWay1: '1 способ',
      modalWay2: '2 способ',
      modalWay1Link: 'Скачай приложение и передай его на свой телефон, либо откройте эту страницу с телефона',
      modalWay1Button: 'СКАЧАТЬ ФАЙЛ',
      modalWay1ButtonSpan: 'ПРИЛОЖЕНИЯ',
      modalWay2Link: 'Открой ссылку на скачивание с телефона, просканировав QR код',
      stepText0: 'Перейди в Настройки \n' +
        'и нажми на свой профиль',
      stepText1: 'Перейди в пункт\n' +
        '“Медиаматериалы и покупки” или “iTunes Store и App Store”',
      stepText2: 'Нажми на свой Apple ID',
      stepText3: 'Перейди в “Просмотреть \n' +
        'Apple ID”',
      stepText4: 'Перейди в пункт “Страна или регион”',
      stepText5: 'Выбери страну “Индия”',
      stepText6: '\n' +
        'Нажми “Принять” или “Готово” справа сверху',
      stepText7: 'Прими условия пользовательского соглашения',
      stepText8: 'Заполни поля как указано на фото (кроме имени и фамилии)',
      stepText9: '\n' +
        'Открой приложение App Store, найди Zenit Bet и установи его',
      stepText10First: 'Если получена ошибка, то необходимо создать новый аккаунт на ',
      stepText10Second: ' в качестве страны укажи Индия',
      stepText10Link: ' сайте ',
      stepText11First: 'Вернись на шаг 4 ',
      stepText11Second: ' и выбери “Выйти”',
      stepText12First: 'Авторизуйся с новым аккаунтом ',
      stepText12Second: ' перейди на шаг 9',
      step1: 'Шаг 1',
      step2: 'Шаг 2',
      step3: 'Шаг 3',
      step4: 'Шаг 4',
      step5: 'Шаг 5',
      step6: 'Шаг 6',
      step7: 'Шаг 7',
      step8: 'Шаг 8',
      step9: 'Шаг 9',
      step10: 'Шаг 10',
      step11: 'Шаг 11',
      step12: 'Шаг 12',
      step13: 'Шаг 13',
      stepTextAndroid1: 'Нажми кнопку OK \n' +
        'и сохрани .apk файл. ',
      stepTextAndroid2: '\n' +
        'Открой скаченный .apk файл. ',
      stepTextAndroid3: 'Отметь пункт «Разрешить установку из этого источника». ',
      stepTextAndroid4: 'После открытия установочного файла, выбери кнопку «Настройки».',
      stepTextAndroid5: 'В появившемся окне нажми «Установить»',
    },
    sw: {
      title: 'Android - Kuwekeza dau za michezo mtandaoni kwenye Alamisho Zenit',
      titlePlay: 'Cheza ukiwa popote!',
      subTitle: 'Matukio yote ya michezo kwenye programu moja',
      button: 'PAKUA KWA AJILI YA',
      instruction: 'Maagizo ya kusakinisha',
      contentTitle: 'Upeperushaji wa moja kwa moja wa matukio makuu',
      smartphone: 'Sasa unaweza kutumia simu yako mahiri kuingia',
      navTitle: 'Kutafuta haraka',
      navText: 'Ina kiolesura ambacho ni rahisi kutumia',
      playTitle: 'Weka mkusanyiko kwa kubofya mara chache',
      playText: 'Angalia historia yako ya kuwekeza dau, weka pesa na uwe mshindi!',
      instructionTitle: 'Mwongozo wa usakinishaji wa Android',
      instructionTitleIos: 'Mwongozo wa usakinishaji wa iOS',
      footerLink: ' yuko tayari kukusaidia ',
      footerText1: 'Ikiwa una maswali yoyote kuhusu kusakinisha au kutumia programu hii, ',
      footerText2: ' unaweza kuwasiliana ',
      modalTitle: 'Nitapataje programu ya Android',
      modalTitleIos: 'Nitapataje programu ya iOS',
      modalText: 'Samahani, huduma za Google Play hazipatikani kwa alamisho. Tunaandaa njia tatu za kupakua programu yetu. Unaweza kuisakinisha kwa kufuata ',
      modalTextLink: ' maagizo rahisi.',
      modalWay1: 'Njia ya 1',
      modalWay2: 'Njia ya 2',
      modalWay1Link: 'Pakua programu na uihamishe kwa simu yako au ufungue ukurasa huu kwenye simu yako',
      modalWay1Button: 'PAKUA FAILI',
      modalWay1ButtonSpan: 'PROGRAMU',
      modalWay2Link: 'Fungua kiungo cha kupakua moja kwa moja kwenye simu yako kwa kuchanganua msimbo wa QR',
      stepText0: ' Fungua Mipangilio na ubofye sehemu ya habari zako',
      stepText1: 'Fungua Media na Purchases au iTunes Store na App Store',
      stepText2: ' Bofya Apple ID yako',
      stepText3: 'Chagua Angalia Apple ID',
      stepText4: ' Chagua Nchi/Mkoa',
      stepText5: ' Chagua India',
      stepText6: 'Bofya Kubali au Imefaulu kwenye kona ya juu kulia',
      stepText7: 'Kubali Sheria & Masharti ya Makubaliano na Mtumiaji',
      stepText8: ' Jaza sehemu zinazoonyeshwa kwenye picha (isipokuwa sehemu ya Jina la Kwanza na Jina la Mwisho)',
      stepText9: ' Fungua App Store, tafuta programu ya Zenit Bet na uisakinishe',
      stepText10First: 'Iwapo kumetokea kasoro, fungua akaunti mpya ',
      stepText10Second: ' na uchague India katika sehemu ya Nchi/Mkoa',
      stepText10Link: ' kwenye tovuti  ',
      stepText11First: ' Rudi kwenye HATUA YA 4 ',
      stepText11Second: ' na uchague Toka',
      stepText12First: ' Ingia kwenye akaunti yako mpya, ',
      stepText12Second: ' enda kwa HATUA YA 9',
      step1: 'HATUA YA 1',
      step2: 'HATUA YA 2',
      step3: 'HATUA YA 3',
      step4: 'HATUA YA 4',
      step5: 'HATUA YA 5',
      step6: 'HATUA YA 6',
      step7: 'HATUA YA 7',
      step8: 'HATUA YA 8',
      step9: 'HATUA YA 9',
      step10: 'HATUA YA 10',
      step11: 'HATUA YA 11',
      step12: 'HATUA YA 12',
      step13: 'HATUA YA 13',
      stepTextAndroid1: ' Bofya OK \n' +
        ' na upakue faili ya APK',
      stepTextAndroid2: 'Fungua faili ya APK iliyosakinishwa',
      stepTextAndroid3: 'Baada ya kufungia faili ya kusakinisha, chagua Mipangilio ',
      stepTextAndroid4: 'Bofya Kichale katika sanduku hili',
      stepTextAndroid5: 'Bofya Sakinisha katika ukurasa uliofunguka',
    },
    tr: {
      title: 'Android - Bookmaker Zenit çevrimiçi spor bahisleri',
      titlePlay: 'Hareket halindeyken oynayın!',
      subTitle: 'Tüm spor etkinlikleri bir uygulamada',
      button: 'İÇİN İNDİR',
      instruction: 'Yükleme talimatları',
      contentTitle: 'Öne çıkan etkinliklerin canlı yayınları',
      smartphone: 'Artık erişmek için akıllı telefonunuzu kullanabilirsiniz',
      navTitle: 'Hızlı gezinme',
      navText: 'Kullanımı kolay bir arabirim ile',
      playTitle: 'Birkaç tıklama ile bir kombine bahis oynayın',
      playText: 'Bahis geçmişinize bakın, para yatırın ve kazanın!',
      instructionTitle: 'Android için kurulum kılavuzu',
      instructionTitleIos: 'iOS için kurulum kılavuzu',
      footerLink: ' size yardımcı olmaya hazır olacaklardır ',
      footerText1: 'Uygulamayı yükleme veya kullanma ile ilgili herhangi bir sorunuz varsa, ',
      footerText2: ' şurayla iletişime geçebilirsiniz',
      modalTitle: 'Android uygulamasını nasıl alabilirim',
      modalTitleIos: 'iOS uygulamasını nasıl alabilirim',
      modalText: 'Üzgünüz, Google Play hizmetleri bahis şirketleri için kullanılamıyor. Uygulamamızı indirmek için 2 yöntem sunuyoruz. Uygulamayı şu ',
      modalTextLink: ' talimatları kullanarak kurabilirsiniz',
      modalWay1: 'Yöntem  1',
      modalWay2: 'Yöntem  2',
      modalWay1Link: 'Uygulamayı indirin ve cep telefonunuza aktarın veya bu sayfayı telefonunuzdan açın',
      modalWay1Button: 'DOSYAYI İNDİRİN',
      modalWay1ButtonSpan: 'UYGULAMALAR',
      modalWay2Link: 'Kare kodu tarayarak telefonunuzda doğrudan indirme bağlantısını açın',
      stepText0: 'Ayarlar\'a gidin ve profilinize dokunun',
      stepText1: ' Medya ve Satın Alınanlar’a veya iTunes Store ve App Store’a gidin',
      stepText2: ' Apple Kimliğinize dokunun',
      stepText3: 'Apple Kimliğini Görüntüle\'ye tıklayın',
      stepText4: 'Ülke/Bölge seçimi yapın',
      stepText5: 'Hindistan\'ı seçin',
      stepText6: 'Sağ üst köşedeki Kabul Et\'e ya da Bitti\'ye tıklayın',
      stepText7: 'Kullanıcı Sözleşmesinin Hüküm ve Koşullarını Kabul Edin',
      stepText8: ' Alanları, fotoğrafta görüldüğü gibi doldurun (Ad ve Soyadı hariç)',
      stepText9: ' App Store’u açın, Zenit Bet uygulamasını bulun ve yükleyin',
      stepText10First: ' Bir hata oluştuysa, ',
      stepText10Second: ' yeni bir hesap oluşturun ve Ülke/Bölge alanından Hindistan\'ı seçin.',
      stepText10Link: ' web sitesinde ',
      stepText11First: '4. ADIMA geri dönün ',
      stepText11Second: ' ve Çık\'ı seçin',
      stepText12First: 'Yeni hesabınıza giriş yapın, ',
      stepText12Second: ' 9. ADIMA gidin',
      step1: 'Adım 1',
      step2: 'Adım 2',
      step3: 'Adım 3',
      step4: 'Adım 4',
      step5: 'Adım 5',
      step6: 'Adım 6',
      step7: 'Adım 7',
      step8: 'Adım 8',
      step9: 'Adım 9',
      step10: 'Adım 10',
      step11: 'Adım 11',
      step12: 'Adım 12',
      step13: 'Adım 13',
      stepTextAndroid1: ' Tamam\'a tıklayın \n' +
        ' ve APK dosyasını indirin.',
      stepTextAndroid2: 'İndirilen APK dosyasını açın ',
      stepTextAndroid3: 'Kurulum dosyasını açtıktan sonra Ayarlar\'ı seçin. ',
      stepTextAndroid4: 'Bu kaynak kutusundan İzin ver’i işaretleyin',
      stepTextAndroid5: 'Açılan pencerede Yükle seçeneğine tıklayın',
    },
    uz: {
      title: 'Android - sportga onlayn stavkalar Zenit BK da',
      titlePlay: 'Istalgan vaqtda va istalgan yerda o‘yna!',
      subTitle: 'Barcha sport hodisalari bitta ilovada',
      button: 'UCHUN YUKLAB OLISH',
      instruction: 'O‘rnatish bo‘yicha yo‘riqnoma',
      contentTitle: 'Top hodisalarning to‘g‘ridan-to‘g‘ri translyatsiyalari',
      smartphone: 'Endi sening smartfoningda',
      navTitle: 'Tezkor navigatsiya',
      navText: 'Hodisalarni aks ettirishning qulay formatlari bilan',
      playTitle: 'Atigi bir nechta klikda ekspresslar to‘pla',
      playText: 'Stavkalar tarixini kuzatib bor, hisobni to‘ldir va yut!',
      instructionTitle: 'Android ga o‘rnatish bo‘yicha yo‘riqnoma',
      instructionTitleIos: 'iOS ga o‘rnatish bo‘yicha yo‘riqnoma',
      footerLink: ' senga bajonidil maslahatlar beradi ',
      footerText1: 'Agar senda ilovani o‘rnatish yoki u bilan ishlash bilan bo‘liq savollar yuzaga kelsa, ',
      footerText2: ' qo‘llab-quvvatlash xizmatimiz',
      modalTitle: 'Android uchun ilova qanday olinadi',
      modalTitleIos: 'iOS uchun ilova qanday olinadi',
      modalText: 'Afsuski, Google Play xizmatlaridan bukmekerlar uchun foydalanib bo‘lmaydi, shuning uchun ham biz uchta usuldan istalgani orqali ilovamizni yuklab olishingni va oddiy yo‘riqnomaga ',
      modalTextLink: ' amal qilgan holda uni o‘rnatishingni taklif qilamiz.',
      modalWay1: '1-usul',
      modalWay2: '2-usul',
      modalWay1Link: 'Ilovani yuklab ol va uni o‘z telefoningga ber yoki telefondan shu sahifani och',
      modalWay1Button: 'FAYLNI YUKLAB OLISH',
      modalWay1ButtonSpan: 'ILOVALAR',
      modalWay2Link: 'Telefonda QR kodni skanerlagan holda yuklab olish havolasini och',
      stepText0: ' Sozlamalarga o‘t va profilingizga bos',
      stepText1: '“Mediamateriallar va xaridlar” yoki “iTunes Store va App Store” bandiga o‘t',
      stepText2: ' O‘z Apple ID ga bos',
      stepText3: ' “Apple ID ni ko‘rish” ga o‘t',
      stepText4: ' "Mamlakat yoki mintaqa" bandiga o‘t',
      stepText5: '"Hindiston" ni tanla',
      stepText6: ' Yuqori o‘ngdagi "Qabul qilish" yoki "Tayyor" tugmasini bos',
      stepText7: ' Foydalanuvchi bilan kelishuv shartlarini qabul qil',
      stepText8: ' Maydonlarni fotosuratda ko‘rsatilgani kabi to‘ldir (ism va familiyadan tashqari)',
      stepText9: ' App Store ilovasini och, Zenit Bet ni top va uni o‘rnat',
      stepText10First: ' Agar xatolik olinsa, ',
      stepText10Second: ' yangi akkaunt yaratish zarur, mamlakat sifatida Hindistonni ko‘rsat',
      stepText10Link: ' saytda  ',
      stepText11First: ' 4-qadamga qayt va ',
      stepText11Second: ' "Chiqish" tugmasini bos',
      stepText12First: ' Yangi akkaunt bilan kir, ',
      stepText12Second: ' 9-qadamga o‘t',
      step1: '1-QADAM',
      step2: '2-QADAM',
      step3: '3-QADAM',
      step4: '4-QADAM',
      step5: '5-QADAM',
      step6: '6-QADAM',
      step7: '7-QADAM',
      step8: '8-QADAM',
      step9: '9-QADAM',
      step10: '10-QADAM',
      step11: '11-QADAM',
      step12: '12-QADAM',
      step13: '13-QADAM',
      stepTextAndroid1: ' OK tugmasini bos \n' +
        ' va .apk faylini saqla.',
      stepTextAndroid2: 'Yuklab olingan .apk faylni och ',
      stepTextAndroid3: 'O‘rnatish faylini ochgandan keyin "Sozlamalar" tugmasini bos. ',
      stepTextAndroid4: '"Shu manbadan o‘rnatishga ruxsat berish" bandini belgila.',
      stepTextAndroid5: 'Paydo bo‘lgan oymada "O‘rnatish" tugmasini bos',
    },
    vi: {
      title: 'Android - Nhà cái cá cược thể thao trực tuyến Zenit',
      titlePlay: 'Chơi khi đang di chuyển!',
      subTitle: 'Tất cả các sự kiện thể thao trong một ứng dụng',
      button: 'TẢI XUỐNG CHO THIẾT BỊ',
      instruction: 'Hướng dẫn cài đặt',
      contentTitle: 'Phát trực tiếp các sự kiện hàng đầu',
      smartphone: 'Bây giờ bạn có thể sử dụng điện thoại thông minh của mình để truy cập',
      navTitle: 'Điều hướng nhanh chóng',
      navText: 'Với giao diện dễ sử dụng',
      playTitle: 'Đặt một bộ tích lũy trong một vài cú nhấp chuột',
      playText: 'Kiểm tra lịch sử cá cược của bạn, nạp tiền và giành chiến thắng!',
      instructionTitle: 'Hướng dẫn cài đặt cho thiết bị Android',
      instructionTitleIos: 'Hướng dẫn cài đặt cho thiết bị iOS',
      footerLink: ' sẵn sàng trợ giúp bạn ',
      footerText1: 'Nếu bạn có bất kỳ câu hỏi nào về việc cài đặt hoặc sử dụng ứng dụng, ',
      footerText2: ' bạn có thể liên hệ',
      modalTitle: 'Cách tải ứng dụng dành cho thiết bị Android',
      modalTitleIos: 'Cách tải ứng dụng dành cho thiết bị iOS',
      modalText: 'Rất tiếc, các dịch vụ của Google Play không có sẵn cho các nhà cái. Chúng tôi cung cấp 3 phương pháp để tải xuống ứng dụng của chúng tôi. Bạn có thể cài đặt bằng cách làm theo ',
      modalTextLink: ' các hướng dẫn đơn giản.',
      modalWay1: 'Phương pháp 1',
      modalWay2: 'Phương pháp 2',
      modalWay1Link: 'Tải xuống ứng dụng và chuyển sang điện thoại di động hoặc mở trang này từ điện thoại của bạn',
      modalWay1Button: 'TẢI XUỐNG TỆP',
      modalWay1ButtonSpan: 'ỨNG DỤNG',
      modalWay2Link: 'Mở liên kết tải xuống trực tiếp trên điện thoại của bạn bằng cách quét mã QR',
      stepText0: 'Đi đến cài đặt và nhấn vào hồ sơ của bạn',
      stepText1: ' Đi đến Phương tiện và Giao dịch mua hoặc tới iTunes Store và App Store',
      stepText2: 'Nhấn vào ID Apple của bạn',
      stepText3: ' Chọn xem Apple ID',
      stepText4: 'Chọn quốc gia/vùng',
      stepText5: ' Chọn Ấn Độ',
      stepText6: 'Nhấn vào Chấp nhận hoặc Hoàn tất ở góc trên cùng bên phải',
      stepText7: 'Chấp nhận các Điều khoản & Điều kiện của Thỏa thuận Người dùng',
      stepText8: 'Điền vào các trường như trong ảnh (ngoại trừ Tên và Họ)',
      stepText9: ' Mở App Store, tìm ứng dụng Zenit Bet và cài đặt',
      stepText10First: 'Nếu xảy ra lỗi, hãy tạo một tài khoản mới trên ',
      stepText10Second: ' và chọn Ấn Độ trong trường Quốc gia/Vùng',
      stepText10Link: '  trang web  ',
      stepText11First: 'Quay lại BƯỚC 4 ',
      stepText11Second: ' và chọn Thoát',
      stepText12First: ' Đăng nhập vào tài khoản mới của bạn, ',
      stepText12Second: ' chuyển sang BƯỚC 9',
      step1: 'Bước 1',
      step2: 'Bước 2',
      step3: 'Bước 3',
      step4: 'Bước 4',
      step5: 'Bước 5',
      step6: 'Bước 6',
      step7: 'Bước 7',
      step8: 'Bước 8',
      step9: 'Bước 9',
      step10: 'Bước 10',
      step11: 'Bước 11',
      step12: 'Bước 12',
      step13: 'Bước 13',
      stepTextAndroid1: 'Nhấn OK \n' +
        ' và tải xuống tệp APK ',
      stepTextAndroid2: 'Mở tệp APK đã tải xuống. ',
      stepTextAndroid3: 'Sau khi mở tệp cài đặt, hãy chọn Cài đặt ',
      stepTextAndroid4: 'Chọn hộp Cho phép từ nguồn này',
      stepTextAndroid5: 'Nhấp vào Cài đặt trong cửa sổ đã mở',
    },
  },
  zenbet: {
    ae: {
      title: 'الرهان على الرياضات على الإنترنت عبر وكيل المراهنات ZENBET- أندرويد',
      titlePlay: 'العب باستمرار',
      subTitle: 'كل الأحداث الرياضية في تطبيق واحد',
      button: 'التنزيل ',
      instruction: 'تعليمات التثبيت',
      contentTitle: 'بث مباشر \n' +
        ' لأفضل الأحداث',
      smartphone: 'الآن يمكنك استخدام هاتفك الذكي للوصول',
      navTitle: 'تصفح سهل',
      navText: 'مع واجهة سهلة الاستخدام',
      playTitle: 'ضع رهانًا تراكمي \n' +
        '  ببضع نقرات',
      playText: 'تفقد سجل مراهنتك، أودع واربح',
      instructionTitle: 'Android دليل التثبيت ',
      instructionTitleIos: 'iOS دليل التثبيت',
      footerLink: ' جاهز لمساعدتك ',
      footerText1: 'يمكنك الاتصال ',
      footerText2: ' إذا كان لديك أية أسئلة عن تثبيت التطبيق أو استخدامه،',
      modalTitle: 'Android كيف أحصل على التطبيق',
      modalTitleIos: 'iOS كيف أحصل على التطبيق',
      modalText: 'نعتذر، خدمات متجر ألعاب جوجل غير متاحة لوكلاء المراهنة. نوفر 3 طرق لتنزيل تطبيقنا. يمكنك تثبيته باتباع ',
      modalTextLink: ' التعليمات البسيطة',
      modalWay1: ' الطريقة رقم 1',
      modalWay2: ' الطريقة رقم 2',
      modalWay1Link: 'نزل التطبيق وانقله لجوالك أو افتح هذه الصفحة من هاتفك',
      modalWay1Button: 'تنزيل الملف',
      modalWay1ButtonSpan: 'التطبيقات',
      modalWay2Link: 'افتح رابط التنزيل المباشر على هاتفك بمسح رمز الاستجابة السريع (QR) ضوئيًا',
      stepText0: ' اذهب إلى الإعدادات\n' +
        ' وانقر ملفك الشخصي.',
      stepText1: ' اذهب إلى الوسائط أو المشتريات أو متجر آي تونز ومتجر أبل.',
      stepText2: ' انقر هوية أبل خاصتك.',
      stepText3: ' اختر عرض هوية أبل',
      stepText4: ' اختر البلد/ المنطقة.',
      stepText5: ' اختر الهند.',
      stepText6: ' انقر موافق أو تم في الركن الأيمن العلوي.',
      stepText7: 'وافق على شروط وأحكام اتفاقية المستخدم.',
      stepText8: ' املأ الحقول كما في الصورة (باستثناء الاسم الأول واللقب) .',
      stepText9: ' افتح متجر أبل، واعثر على تطبيق ZENBET وثبته.',
      stepText10First: 'إذا وقع خطأ ما، أنشئ حسابًا جديدًا على ',
      stepText10Second: ' واختر الهند في حقل البلد/ المنطقة.',
      stepText10Link: ' الموقع ',
      stepText11First: 'عد إلى الخطوة 4 ',
      stepText11Second: '  واختر خروج.',
      stepText12First: 'سجل الدخول إلى حسابك الجديد،  ',
      stepText12Second: ' اذهب للخطوة 9.',
      step1: ' 1 الخطوة ' ,
      step2: ' 2 الخطوة ' ,
      step3: ' 3 الخطوة ' ,
      step4: ' 4 الخطوة ' ,
      step5: ' 5 الخطوة ' ,
      step6: ' 6 الخطوة ' ,
      step7: ' 7 الخطوة ' ,
      step8: ' 8 الخطوة ' ,
      step9: ' 9 الخطوة ' ,
      step10: ' 10 الخطوة ',
      step11: ' 11 الخطوة ',
      step12: ' 12 الخطوة ',
      step13: ' 13 الخطوة ',
      stepTextAndroid1: ' انقر موافق \n' +
        'ونزّل الملف بامتداد APK.',
      stepTextAndroid2: 'افتح الملف بامتداد APK الذي نزلته. ',
      stepTextAndroid3: ' اختر سماح من هذا المصدر. ',
      stepTextAndroid4: ' بعد فتح ملف التثبيت، اختر الإعدادات.',
      stepTextAndroid5: 'في الشاشة التالية، اختر تثبيت.',
    },
    bn: {
      title: 'অ্যান্ড্রয়েড - বুকমেকার ZENBET অনলাইন স্পোর্টস বাজি',
      titlePlay: 'চলতে চলতে খেলুন!',
      subTitle: 'একটিমাত্র অ্যাপে ক্রীড়ার সমস্ত ইভেন্ট',
      button: 'জন্য ডাউনলোড করুন',
      instruction: 'ইনস্টলেশনের নির্দেশাবলী',
      contentTitle: 'শীর্ষ ইভেন্টগুলোর সরাসরি সম্প্রচার',
      smartphone: 'এখন আপনি আপনার স্মার্টফোনটি ব্যবহার করে অ্যাক্সেস করতে পারেন',
      navTitle: 'দ্রুত ন্যাভিগেশন',
      navText: 'সহজেই ব্যবহারযোগ্য ইন্টারফেসের সঙ্গে',
      playTitle: 'কয়েক ক্লিকে একটি অ্যাকুমুলেটর রাখুন',
      playText: 'আপনার বাজি ধরার ইতিহাস দেখুন, জমা দিন এবং জিতুন!',
      instructionTitle: 'Android-এর জন্য ইনস্টলেশন গাইড',
      instructionTitleIos: 'iOS-এর জন্য ইনস্টলেশন গাইড',
      footerLink: ' আপনাকে সাহায্য করতে প্রস্তুত ',
      footerText1: 'অ্যাপ ইনস্টল বা ব্যবহার সম্পর্কে আপনার যদি কোনও প্রশ্ন থাকে, ',
      footerText2: '  আপনি যোগাযোগ করতে পারেন',
      modalTitle: 'আমি কিভাবে Android-এর জন্য অ্যাপটি পাব',
      modalTitleIos: 'আমি কিভাবে iOS-এর জন্য অ্যাপটি পাব',
      modalText: 'আমরা দুঃখিত, Google Play সার্ভিস বুকমেকার-এর জন্য পাওয়া যাবে না। আমরা আমাদের অ্যাপটি ডাউনলোড করার জন্য 3 টি পদ্ধতি অফার করছি। আপনি এই সহজ নির্দেশাবলীগুলো অনুসরণ করে ',
      modalTextLink: ' এটি ইনস্টল করতে পারেন।',
      modalWay1: 'পদ্ধতি 1',
      modalWay2: 'পদ্ধতি 2',
      modalWay1Link: 'অ্যাপটি ডাউনলোড করুন এবং আপনার মোবাইল ফোনে ট্রান্সফার করুন বা আপনার ফোন থেকে এই পেজটি খুলুন',
      modalWay1Button: 'ডাউনলোড ফাইল',
      modalWay1ButtonSpan: 'অ্যাপগুলি',
      modalWay2Link: 'QR কোডটি স্ক্যান করে আপনার ফোনে সরাসরি ডাউনলোড লিঙ্কটি খুলুন',
      stepText0: ' সেটিংস-এ যান এবং আপনার প্রোফাইলটি আলতো চাপুন',
      stepText1: 'মিডিয়া এবং ক্রয়-এ যান অথবা iTunes স্টোর এবং অ্যাপ স্টোরে যান',
      stepText2: 'আপনার Apple আইডি আলতো চাপুন',
      stepText3: ' Apple আইডি দেখুন নির্বাচন করুন',
      stepText4: 'দেশ/অঞ্চল নির্বাচন করুন',
      stepText5: ' ভারত নির্বাচন করুন',
      stepText6: ' উপরের ডান কোণায় থাকা স্বীকার করুন বা সম্পন্ন হয়েছে আলতো চাপুন',
      stepText7: 'ব্যবহারকারীর চুক্তির শর্তাবলী স্বীকার করুন',
      stepText8: ' ছবিতে দেখানো ঘরগুলো পূরণ করুন (নামের প্রথম অংশ এবং শেষ অংশ বাদে)',
      stepText9: ' অ্যাপ স্টোর খুলুন, ZENBET Bet অ্যাপটি খুঁজুন এবং এটি ইন্সটল করুন',
      stepText10First: ' যদি কোনো ত্রুটি ঘটে থাকে, তাহলে ',
      stepText10Second: ' একটি নতুন অ্যাকাউন্ট তৈরি করুন এবং দেশ/অঞ্চলের ক্ষেত্রে ভারত নির্বাচন করুন',
      stepText10Link: ' ওয়েবসাইটে ',
      stepText11First: 'ধাপ 4 এ ফিরে যান  ',
      stepText11Second: ' এবং প্রস্থান নির্বাচন করুন',
      stepText12First: 'আপনার নতুন অ্যাকাউন্টে সাইন ইন করুন, ',
      stepText12Second: ' ধাপ 9-এ যান',
      step1: 'ধাপ 1',
      step2: 'ধাপ 2',
      step3: 'ধাপ 3',
      step4: 'ধাপ 4',
      step5: 'ধাপ 5',
      step6: 'ধাপ 6',
      step7: 'ধাপ 7',
      step8: 'ধাপ 8',
      step9: 'ধাপ 9',
      step10: 'ধাপ 10',
      step11: 'ধাপ 11',
      step12: 'ধাপ 12',
      step13: 'ধাপ 13',
      stepTextAndroid1: 'ঠঠিক আছে আলতো চাপুন \n' +
        'এবং APK ফাইলটি ডাউনলোড করুন।',
      stepTextAndroid2: 'ডাউনলোড করা APK ফাইলটি খুলুন ',
      stepTextAndroid3: 'ইনস্টলেশন ফাইল খোলার পরে, সেটিংস নির্বাচন করুন ',
      stepTextAndroid4: 'এই উৎসের বাক্স থেকে অ্যালাউ চেক করুন',
      stepTextAndroid5: 'খোলা উইন্ডোতে ইনস্টল ক্লিক করুন',
    },
    br: {
      title: 'Android - ZENBET Apostas Esportivas Online',
      titlePlay: 'Jogue no celular!',
      subTitle: 'Todos os eventos esportivos em um aplicativo',
      button: 'BAIXE PARA',
      instruction: 'Instruções de instalação',
      contentTitle: 'Transmissões ao vivo\n' +
        'dos principais eventos',
      smartphone: 'Agora você pode usar o seu smartphone para acessar',
      navTitle: 'Navegação rápida',
      navText: 'Com uma interface fácil de usar',
      playTitle: 'Efetue uma aposta acumuladora\n' +
        'com apenas alguns cliques',
      playText: 'Consulte o seu histórico de apostas, faça depósitos e ganhe!',
      instructionTitle: 'Guia de instalação para Android',
      instructionTitleIos: 'Guia de instalação para iOS',
      footerLink: '  equipe de suporte  ',
      footerText1: 'Se você tiver alguma dúvida sobre como instalar ou usar o aplicativo, nossa ',
      footerText2: ' está aqui para ajudar',
      modalTitle: 'Como obter o aplicativo para Android?',
      modalTitleIos: 'Como obter o aplicativo para iOS',
      modalText: 'Lamentamos, mas o serviços do Google Play não estão disponíveis para apostadores. Oferecemos dois métodos alternativos para baixar nosso aplicativo. Siga as ',
      modalTextLink: ' instruções simples de instalação abaixo',
      modalWay1: 'Método 1',
      modalWay2: 'Método 2',
      modalWay1Link: 'Baixe o app e transfira-o para seu celular ou abra esta página no seu telefone',
      modalWay1Button: 'BAIXE O ARQUIVO DE ',
      modalWay1ButtonSpan: 'INSTALAÇÃO',
      modalWay2Link: 'Abra o link de download diretamente no seu telefone, escaneando o código QR',
      stepText0: ' Vá para Configurações e toque no seu perfil',
      stepText1: ' Vá para Mídia e Compras ou para a Loja iTunes e App Store',
      stepText2: ' Toque na ID Apple',
      stepText3: 'Selecione Ver ID Apple',
      stepText4: 'Selecione país/região',
      stepText5: 'Selecione Índia',
      stepText6: 'Toque em Aceitar ou OK no canto superior direito',
      stepText7: 'Aceite os Termos e Condições do Acordo de Usuário',
      stepText8: 'Preencha os campos conforme exibido na imagem (exceto para Nome e Sobrenome)',
      stepText9: ' Abra a App Store, localize o app ZENBET e instale',
      stepText10First: ' Se um erro ocorreu, crie uma nova conta no ',
      stepText10Second: ' selecione Índia no campo país/região',
      stepText10Link: ' site  ',
      stepText11First: 'Volte ao PASSO 4 ',
      stepText11Second: ' e selecione Sair',
      stepText12First: 'Faça login na nova conta ',
      stepText12Second: ' e vá para o PASSO 9',
      step1: 'PASSO 1',
      step2: 'PASSO 2',
      step3: 'PASSO 3',
      step4: 'PASSO 4',
      step5: 'PASSO 5',
      step6: 'PASSO 6',
      step7: 'PASSO 7',
      step8: 'PASSO 8',
      step9: 'PASSO 9',
      step10: 'PASSO 10',
      step11: 'PASSO 11',
      step12: 'PASSO 12',
      step13: 'PASSO 13',
      stepTextAndroid1: ' Toque em OK e baixe o arquivo APK',
      stepTextAndroid2: 'Abra o arquivo APK baixado',
      stepTextAndroid3: 'Após abrir o arquivo de instalação, selecione Configurações',
      stepTextAndroid4: 'Marque a opção Permitir desta caixa de fonte',
      stepTextAndroid5: 'Clique em Instalar na janela aberta',
    },
    de: {
      title: 'Android – Buchmacher ZENBET Online-Sportwetten',
      titlePlay: 'Spielen von unterwegs!',
      subTitle: 'Alle Sportereignisse in einer App',
      button: 'HERUNTERLADEN FÜR',
      instruction: 'Installationsanleitung',
      contentTitle: 'Live-Übertragung von Top-Ereignissen',
      smartphone: 'Jetzt können Sie mit Ihrem Smartphone auf',
      navTitle: 'Schnelle Navigation',
      navText: 'Mit einer einfach zu bedienenden Oberfläche',
      playTitle: 'Platzieren eines Akkumulators mit nur wenigen Mausklicks',
      playText: 'Überprüfen Sie Ihre Wetthistorie, tätigen Sie Einzahlungen und gewinnen Sie!',
      instructionTitle: 'Installationsanleitung für Android',
      instructionTitleIos: 'Installationsanleitung für iOS',
      footerLink: ' unser Support-Team ',
      footerText1: 'Wenn Sie Fragen zur Installation oder Verwendung der App haben, steht Ihnen ',
      footerText2: ' zur Verfügung',
      modalTitle: 'Wie bekomme ich die App für Android',
      modalTitleIos: 'Wie bekomme ich die App für iOS',
      modalText: 'Es tut uns leid, die Dienste von Google Play sind für Buchmacher nicht verfügbar. Wir bieten 2 Methoden an, um unsere App herunterzuladen. Sie können sie installieren, indem Sie die',
      modalTextLink: ' einfachen Anweisungen befolgen.',
      modalWay1: 'Methode 1',
      modalWay2: 'Methode 2',
      modalWay1Link: 'Laden Sie die App herunter und übertragen Sie sie auf Ihr Mobiltelefon oder öffnen Sie diese Seite von Ihrem Telefon aus',
      modalWay1Button: 'DATEI HERUNTERLADEN',
      modalWay1ButtonSpan: 'APPS',
      modalWay2Link: 'Öffnen Sie den Link für den direkten Download auf Ihrem Telefon durch Scannen des QR-Codes',
      stepText0: ' Gehen Sie zu "Einstellungen" und tippen Sie auf Ihr Profil',
      stepText1: 'Gehen Sie zu "Medien und Einkäufe" oder zum iTunes Store und App Store',
      stepText2: 'Tippen Sie auf Ihre Apple ID',
      stepText3: ' Wählen Sie Apple ID anzeigen',
      stepText4: ' Wählen Sie Land/Region aus',
      stepText5: ' Wählen Sie Indien aus',
      stepText6: 'Tippen Sie oben rechts auf "Akzeptieren" oder "Fertig"',
      stepText7: 'Bedingungen der allgemeinen Geschäftsbedingungen akzeptieren',
      stepText8: 'Füllen Sie die Felder aus, die auf dem Foto zu sehen sind (außer Vor- und Nachname)',
      stepText9: 'Öffnen Sie den App Store, suchen Sie die ZENBET-App und installieren Sie sie',
      stepText10First: 'Wenn ein Fehler aufgetreten ist, erstellen Sie ein neues Konto auf der ',
      stepText10Second: ' und wählen Sie "Indien" im Feld "Land/Region"',
      stepText10Link: ' Webseite  ',
      stepText11First: ' Gehen Sie zurück zu SCHRITT 4 ',
      stepText11Second: ' und wählen Sie "Beenden”',
      stepText12First: ' Melden Sie sich bei Ihrem neuen Konto an  ',
      stepText12Second: ' und gehen Sie zu Schritt 9',
      step1: 'Schritt 1',
      step2: 'Schritt 2',
      step3: 'Schritt 3',
      step4: 'Schritt 4',
      step5: 'Schritt 5',
      step6: 'Schritt 6',
      step7: 'Schritt 7',
      step8: 'Schritt 8',
      step9: 'Schritt 9',
      step10: 'Schritt 10',
      step11: 'Schritt 11',
      step12: 'Schritt 12',
      step13: 'Schritt 13',
      stepTextAndroid1: 'Tippen Sie auf OK \n' +
        ' und laden Sie die APK-Datei herunter',
      stepTextAndroid2: 'Öffnen Sie die heruntergeladene APK-Datei ',
      stepTextAndroid3: 'Nachdem Sie die Installationsdatei geöffnet haben, wählen Sie "Einstellungen". ',
      stepTextAndroid4: 'Aktivieren Sie die Option "Von dieser Quelle zulassen"',
      stepTextAndroid5: 'Klicken Sie im sich geöffneten Fenster auf "Installieren"',
    },
    en: {
      title: 'Android - Bookmaker ZENBET online sports betting',
      titlePlay: 'Play on the go!',
      subTitle: 'Play on the go!',
      button: 'DOWNLOAD FOR',
      instruction: 'Installation instructions',
      contentTitle: 'Live broadcasts of top events',
      smartphone: 'Now you can use your smartphone to access',
      navTitle: 'Fast navigation',
      navText: 'With an easy-to-use interface',
      playTitle: 'Place an accumulator in a few clicks',
      playText: 'Check your betting history, make deposits and win!',
      instructionTitle: 'Installation guide for Android',
      instructionTitleIos: 'Installation instructions on iOS',
      footerLink: ' our support team ',
      footerText1: 'If you have any questions on how to install or use the app, ',
      footerText2: ' is here to help you',
      modalTitle: 'How do I get the app for Android',
      modalTitleIos: 'How do I get the app for iOS',
      modalText: 'We are sorry, Google Play services are not available to bookmakers. We offer two methods to download our app. You can install it by following the ',
      modalTextLink: ' simple instructions',
      modalWay1: 'Method 1',
      modalWay2: 'Method 2',
      modalWay1Link: 'Download the app and transfer it to your mobile phone or open this page over your phone',
      modalWay1Button: 'DOWNLOAD THE ',
      modalWay1ButtonSpan: 'SETUP FILE',
      modalWay2Link: 'Open the direct download link on your phone by scanning the QR code',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
      step4: 'Step 4',
      step5: 'Step 5',
      step6: 'Step 6',
      step7: 'Step 7',
      step8: 'Step 8',
      step9: 'Step 9',
      step10: 'Step 10',
      step11: 'Step 11',
      step12: 'Step 12',
      step13: 'Step 13',
      stepTextAndroid1: 'Press the button OK and save .apk file.',
      stepTextAndroid2: 'Open the downloaded .apk file.',
      stepTextAndroid3: 'After opening the installation file, select the "Settings" button.',
      stepTextAndroid4: 'Check the box "Allow installation from this source."',
      stepTextAndroid5: 'Click “Install” in appeared window',
    },
    fr: {
      title: 'Android - Bookmaker ZENBET paris sportifs en ligne',
      titlePlay: 'Jouez quand vous êtes en déplacement!',
      subTitle: 'Tous les événements sportifs dans une seule application',
      button: 'TÉLÉCHARGEMENT POUR',
      instruction: 'Instructions d\'installation',
      contentTitle: 'Diffusions en direct des principaux événements',
      smartphone: 'Vous pouvez désormais utiliser votre smartphone pour accéder',
      navTitle: 'Navigation rapide',
      navText: 'Avec une interface facile à utiliser',
      playTitle: 'PLACEZ UN ACCUMULATEUR EN QUELQUES CLICS',
      playText: 'Consultez l\'historique de vos paris, effectuez des dépôts et gagnez!',
      instructionTitle: 'Guide d\'installation pour Android',
      instructionTitleIos: 'Guide d\'installation pour iOS',
      footerLink: '  notre équipe d\'assistance ',
      footerText1: 'Pour toute question sur la manière d\'installer ou d\'utiliser l\'application,  ',
      footerText2: ' est prête à vous aider',
      modalTitle: 'Comment obtenir l\'application pour Android',
      modalTitleIos: 'Comment obtenir l\'application pour iOS',
      modalText: 'Nous sommes désolés, les services de Google Play ne sont pas disponibles pour les bookmakers. Nous proposons 2 méthodes pour télécharger notre application. Vous pouvez l\'installer en suivant ',
      modalTextLink: ' ces instructions simples.',
      modalWay1: 'Méthode 1',
      modalWay2: 'Méthode 2',
      modalWay1Link: 'Téléchargez l\'application et transférez-la sur votre téléphone portable, ou ouvrez cette page depuis votre téléphone',
      modalWay1Button: 'TÉLÉCHARGER LE FICHIER',
      modalWay1ButtonSpan: 'APPLICATIONS',
      modalWay2Link: 'Ouvrez le lien de téléchargement direct sur votre téléphone en scannant le code QR',
      stepText0: 'Allez à Paramètres et appuyez sur votre profile',
      stepText1: ' Allez à Média et Achats ou dans iTunes Store et App Store',
      stepText2: 'Appuyez sur votre identifiant Apple',
      stepText3: 'Sélectionnez Afficher l\'identifiant Apple',
      stepText4: 'Sélectionnez Pays/Région',
      stepText5: 'Sélectionnez Inde',
      stepText6: 'Appuyez sur Accepter ou Terminé dans le coin supérieur droit',
      stepText7: ' Acceptez les Conditions générales du Contrat d\'utilisateur',
      stepText8: 'Renseignez les champs comme illustré sur la photo (sauf pour le prénom et le nom)',
      stepText9: 'Ouvrez l\'App Store, trouvez l\'application ZENBET et installez-la',
      stepText10First: 'Si un message d\'erreur s\'affiche, créez un nouveau compte sur ',
      stepText10Second: ' et sélectionnez Inde dans le champ Pays/Région',
      stepText10Link: ' le site Web ',
      stepText11First: 'Revenez à ÉTAPE 4 ',
      stepText11Second: ' et sélectionnez Quitter',
      stepText12First: 'Connectez-vous à votre nouveau compte, ',
      stepText12Second: ' passez à ÉTAPE 9',
      step1: 'Étape 1',
      step2: 'Étape 2',
      step3: 'Étape 3',
      step4: 'Étape 4',
      step5: 'Étape 5',
      step6: 'Étape 6',
      step7: 'Étape 7',
      step8: 'Étape 8',
      step9: 'Étape 9',
      step10: 'Étape 10',
      step11: 'Étape 11',
      step12: 'Étape 12',
      step13: 'Étape 13',
      stepTextAndroid1: 'Appuyez sur OK \n' +
        ' pour télécharger le fichier APK.',
      stepTextAndroid2: 'Ouvrez le fichier APK téléchargé. ',
      stepTextAndroid3: 'Après avoir ouvert le fichier d\'installation, sélectionnez Paramètres ',
      stepTextAndroid4: 'Cochez l\'option Autoriser à partir de cette boîte de base',
      stepTextAndroid5: 'Cliquez sur Installer dans la fenêtre qui s\'est ouverte',
    },
    ir: {
      title: 'اندروید - بنگاه شرط‌بندی آنلاین ZENBET برای رویدادهای ورزشی',
      titlePlay: 'بازی در همه حال!',
      subTitle: 'تمام رویدادهای ورزشی در یک برنامه',
      button: 'دانلود برای',
      instruction: 'راهنمای نصب',
      contentTitle: 'پخش زنده\n' +
        'رویدادهای مهم',
      smartphone: 'اکنون می‌توانید برای دسترسی از موبایل خود استفاده کنید',
      navTitle: 'پیمایش سریع',
      navText: 'با رابط کاربری ساده',
      playTitle: 'شرط ترکیبی\n' +
        'فقط با چند کلیک',
      playText: 'بررسی شرط‌های قبلی، واریز وجه، و برد!',
      instructionTitle: 'راهنمای نصب Android',
      instructionTitleIos: 'راهنمای نصب iOS',
      footerLink: '  پشتیبانی ما  ',
      footerText1: 'اگر سوالی در خصوص نحوه‌ی نصب یا استفاده از برنامه دارید، تیم ',
      footerText2: ' آماده راهنمایی شماست.',
      modalTitle: 'برنامه Android را چگونه دریافت کنم',
      modalTitleIos: 'برنامه iOS را چگونه دریافت کنم',
      modalText: ' متأسفانه خدمات گوگل پلی برای بنگاه‌های شرط‌بندی مجاز نیست. دو روش برای دانلود برنامه ما وجود دارد.می‌توانید برنامه را با کمک راهنمایی‌های زیر به راحتی ',
      modalTextLink: ' نصب کنید ',
      modalWay1: 'روش اول',
      modalWay2: 'روش دوم',
      modalWay1Link: 'برنامه را دانلود کنید و آن را به تلفن همراه‌تان منتقل کنید یا اینکه این صفحه را با تلفن همراه‌تان باز کنید.',
      modalWay1Button: 'دانلود فایل ',
      modalWay1ButtonSpan: ' نصب',
      modalWay2Link: 'لینک دانلود مستقیم را با اسکن کردن کد QR با موبایل خود باز کنید',
      stepText0: ' به تنظیمات بروید و روی پروفایل خود بزنید.',
      stepText1: ' به رسانه و خریدها یا فروشگاه iTunes یا اپ استوربروید.',
      stepText2: 'روی اپل آیدی خود بزنید.',
      stepText3: ' گزینه مشاهده پل آیدی را بزنید.',
      stepText4: ' انتخاب کشور/منطقه”',
      stepText5: 'کشور هند را انتخاب کنید',
      stepText6: ' روی گزینه Accept یا Done در بالا سمت راست بزنید',
      stepText7: ' با شرایط و ضوابط توافق‌نامه‌ی کاربر موافقت کنید',
      stepText8: ' جای‌خالی را مشابه تصویر پر کنید (به استثنای نام و نام خانوادگی)',
      stepText9: ' اپ استور را باز کنید، برنامه ZENBET را پیدا کرده و روی گزینه نصب بزنید.',
      stepText10First: '  اگر خطایی رخ داد، یک حساب کاربری جدید در ',
      stepText10Second: ' ایجاد کنید و در قسمت کشور/منطقه هند را انتخاب کنید.',
      stepText10Link: '  وب‌سایت ',
      stepText11First: 'به مرحله ۴ مراجعه کنید و خروج',
      stepText11Second: ' یا Exit را انتخاب کنید.',
      stepText12First: 'وارد حساب کاربری جدیدتان شوید و ',
      stepText12Second: '  به مرحله ۹ بروید.',
      step1: 'مرحله ۱',
      step2: 'مرحله ۲',
      step3: 'مرحله ۳',
      step4: 'مرحله ۴',
      step5: 'مرحله ۵',
      step6: 'مرحله ۶',
      step7: 'مرحله ۷ ',
      step8: 'مرحله ۸',
      step9: 'مرحله ۹',
      step10: 'مرحله ۱۰',
      step11: 'مرحله ۱۱',
      step12: 'مرحله ۱۲',
      step13: 'مرحله ۱۳',
      stepTextAndroid1: ' روی OK بزنید\n' +
        ' و فایل APK را دانلود کنید.',
      stepTextAndroid2: 'فایل APK دانلود شده را باز کنید',
      stepTextAndroid3: 'بعد از باز کردن فایل نصبی، «تنظیمات» را انتخاب کنید',
      stepTextAndroid4: 'گزینه‌ی «مجاز از این منبع» را تیک بزنید',
      stepTextAndroid5: 'در پنجره‌ی باز شده روی «نصب» کلیک کنید',
    },
    kz: {
      title: 'Android - ZENBET БК спортына онлайн-ұтыстар',
      titlePlay: 'Кез келген уақытта және кез келген жерде ойна!',
      subTitle: 'Спорттың барлық шаралары бір қолданбада',
      button: ' ҮШІН ЖҮКТЕП АЛУ',
      instruction: 'Орнату нұсқаулығы',
      contentTitle: 'Үздік іс-шаралардың тікелей трансляциясы',
      smartphone: 'Енді сенің смартфоныңда',
      navTitle: 'Жылдам навигация',
      navText: 'Іс-шараларды көрсетудің ыңғайлы форматымен',
      playTitle: 'Бар болғаны бірнеше рет басу арқылы экспрестерді жина',
      playText: 'Ұтыстардың тарихын қадағала, шотыңды толтырып, ақша ұт!',
      instructionTitle: 'Android құрылғысына орнату туралы нұсқаулық',
      instructionTitleIos: 'iOS құрылғысына орнату туралы нұсқаулық',
      footerLink: ' қолдау қызметіміз ',
      footerText1: 'Орнату жөнінде немесе қолданба жұмысы бойынша сұрақтар туындаса, біздің ',
      footerText2: ' саған қуана кеңес береді',
      modalTitle: 'Қолданбаны Android құрылғысына қалай алуға болады',
      modalTitleIos: 'Қолданбаны iOS құрылғысына қалай алуға болады',
      modalText: 'Өкінішке орай, букмекерлер үшін Google Play қызметтері қолжетімді емес, сондықтан біз саған екі әдістің кез келгенін пайдаланып біздің қолданы жүктеп алуды және ',
      modalTextLink: ' қарапайым нұсқауларды',
      modalTextKZ: 'орындап орнатуды ұсынамыз.',
      modalWay1: '1-әдіс',
      modalWay2: '2-әдіс',
      modalWay1Link: 'Қолданбаны жүктеп алып, оны өз телефоныңызға жіберіңіз немесе осы бетті телефоннан ашыңыз',
      modalWay1ButtonKZ: 'ҚОЛДАНБА ',
      modalWay1Button: 'ФАЙЛЫН ЖҮКТЕП АЛУ',
      modalWay1ButtonSpan: '',
      modalWay2Link: 'QR кодын сканерлеу арқылы телефоннан жүктеп алу сілтемесін ашыңыз',
      stepText0: 'Параметрлерге өтіп, өз профиліңді таңда',
      stepText1: '“Медиаматериалдар мен сатып алулар” немесе “iTunes Store және App Store” тармағына өт',
      stepText2: 'Өз Apple ID идентифакторыңды бас',
      stepText3: ' “Apple ID қарау” тармағына өт',
      stepText4: '“Ел немесе аймақ” тармағына өт',
      stepText5: '“Үндістан” елін таңда',
      stepText6: ' Жоғарғы оң жақтағы “Қабылдау” немесе “Дайын” түймесін бас',
      stepText7: 'Пайдаланушы келісімінің шарттарын қабылда',
      stepText8: ' Суретте көрсетілгендей өрісті толтыр (аты мен тегінен басқа)',
      stepText9: ' App Store қолданбасын аш, Зенбен қолданбасын тап та, оны орнат',
      stepText10First: 'Қате алынса, ',
      stepText10Second: ' жаңа аккаунтты жасау қажет, ел ретінде Үндістанды көрсет',
      stepText10Link: ' сайтта  ',
      stepText11First: '4-қадамға орал да, ',
      stepText11Second: ' “Шығу” параметрін таңда',
      stepText12First: 'Жаңа аккаунтпен авторизациядан өт те, ',
      stepText12Second: ' 9-қадамға өт',
      step1: '1-ҚАДАМ',
      step2: '2-ҚАДАМ',
      step3: '3-ҚАДАМ',
      step4: '4-ҚАДАМ',
      step5: '5-ҚАДАМ',
      step6: '6-ҚАДАМ',
      step7: '7-ҚАДАМ',
      step8: '8-ҚАДАМ',
      step9: '9-ҚАДАМ',
      step10: '1-ҚАДАМ0',
      step11: '1-ҚАДАМ1',
      step12: '1-ҚАДАМ2',
      step13: '1-ҚАДАМ3',
      stepTextAndroid1: ' OK түймесін басып, .apk файлын сақта',
      stepTextAndroid2: 'Жүктеп алынған .apk файлын аш',
      stepTextAndroid3: 'Орнату файлын ашқан соң, «Параметрлер» түймесін таңдаңыз',
      stepTextAndroid4: '«Осы дереккөзден орнатуға рұқсат ету» тармағын белгілеңіз',
      stepTextAndroid5: 'Пайда болған терезеде «Орнату» түймесін басыңыз',
    },
    mx: {
      title: 'Android - apuestas deportivas en línea con Bookmaker ZENBET',
      titlePlay: '¡Juegue sobre la marcha!',
      subTitle: 'Todos los eventos deportivos en una aplicación',
      button: 'DESCARGA PARA',
      instruction: 'Instrucciones de instalación',
      contentTitle: 'Transmisión en directo de los principales eventos',
      smartphone: 'Ahora puede usar su smartphone para acceder\u00A0a',
      navTitle: 'Navegación rápida',
      navText: 'Con una interfaz fácil de usar',
      playTitle: 'Coloque un acumulador en unos cuantos clics',
      playText: '¡Revise su historial de apuestas, realice depósitos y gane!',
      instructionTitle: 'Guía de instalación para Android',
      instructionTitleIos: 'Guía de instalación para iOS',
      footerLink: '  de suporte está aqui  ',
      footerText1: 'Se você tiver alguma dúvida sobre como instalar ou usar o aplicativo, nossa equipe ',
      footerText2: ' para ajudar',
      modalTitle: 'Cómo obtengo la aplicación para Android',
      modalTitleIos: 'Cómo obtengo la aplicación para iOS',
      modalText: 'Lo sentimos, los servicios de Google Play no están disponibles para Bookmakers. Ofrecemos 2 métodos para descargar nuestra aplicación. Puede instalarla siguiendo ',
      modalTextLink: ' las instrucciones simples.',
      modalWay1: 'Método 1',
      modalWay2: 'Método 2',
      modalWay1Link: 'Descargue la aplicación y transfiérala a su teléfono móvil o abra esta página desde su teléfono',
      modalWay1Button: 'DESCARGAR ARCHIVO',
      modalWay1ButtonSpan: 'APLICACIONES',
      modalWay2Link: 'Escanee el código QR para abrir el enlace de descarga directa en su teléfono',
      stepText0: 'Vaya a Ajustes y toque en su perfil',
      stepText1: 'Vaya a Media y Compras o a Tienda iTunes Store y Tienda de Aplicaciones',
      stepText2: 'Toque su Apple ID',
      stepText3: ' Seleccione Vista Apple ID',
      stepText4: ' Seleccione país/región',
      stepText5: 'Seleccione India',
      stepText6: 'Toque Aceptar o Hecho en la esquina superior derecha',
      stepText7: 'Acepte los Términos y Condiciones del Acuerdo de Usuario',
      stepText8: ' Complete los campos tal y como se ve en la foto (exepto en Nombre y Apellido)',
      stepText9: 'Abrir la Tienda de Aplicaciones, busque la aplicación ZENBET e instálela',
      stepText10First: ' Si ha tenido lugar un error, cree una nueva cuenta en  ',
      stepText10Second: ' y seleccione India en el campo de País/Región',
      stepText10Link: ' el sitio web ',
      stepText11First: 'Regrese al paso 4 ',
      stepText11Second: ' y seleccione Salir',
      stepText12First: 'entre en su nueva cuenta, ',
      stepText12Second: ' vaya al PASO 9',
      step1: 'PASO 1',
      step2: 'PASO 2',
      step3: 'PASO 3',
      step4: 'PASO 4',
      step5: 'PASO 5',
      step6: 'PASO 6',
      step7: 'PASO 7',
      step8: 'PASO 8',
      step9: 'PASO 9',
      step10: 'PASO 10',
      step11: 'PASO 11',
      step12: 'PASO 12',
      step13: 'PASO 13',
      stepTextAndroid1: ' Toque Aceptar y descargue el archivo APK.',
      stepTextAndroid2: 'Abra el archivo APK descargado',
      stepTextAndroid3: 'Después de abrir el enlace o el archivo de instalación, seleccione Configuración.',
      stepTextAndroid4: 'Marque la opción Permitir desde esta fuente',
      stepTextAndroid5: 'Haga clic en Instalar en la ventana abierta',

    },
    ru: {
      title: 'android - Онлайн-ставки на спорт БК ZENBET',
      titlePlay: 'Играй всегда и везде!',
      subTitle: 'Все события спорта в одном приложении',
      button: 'СКАЧАТЬ ДЛЯ',
      instruction: 'Инструкция по установке',
      contentTitle: 'Прямые трансляции топовых событий',
      smartphone: 'Теперь в твоем смартфоне',
      navTitle: 'Быстрая навигация',
      navText: 'C удобными форматами отображения событий',
      playTitle: 'Собирай экспрессы всего за пару кликов',
      playText: 'Следи за историей ставок, пополняй счет и выигрывай!',
      instructionTitle: 'Инструкция по установке на Android',
      instructionTitleIos: 'Инструкция по установке на iOS',
      footerLink: ' наша служба поддержки ',
      footerText1: 'Если у тебя возникли вопросы с установкой или работой приложения, ',
      footerText2: ' с радостью тебя проконсультирует',
      modalTitle: 'Как получить приложение для Android',
      modalTitleIos: 'Как получить приложение для iOS',
      modalText: 'К сожалению, сервисы Google Play недоступны для букмекеров, поэтому мы предлагаем тебе скачать наше ' +
        'приложение любым из двух способов и установить его следуя ',
      modalTextLink: ' простой инструкции',
      modalWay1: '1 способ',
      modalWay2: '2 способ',
      modalWay1Link: 'Скачай приложение и передай его на свой телефон, либо откройте эту страницу с телефона',
      modalWay1Button: 'СКАЧАТЬ ФАЙЛ',
      modalWay1ButtonSpan: 'ПРИЛОЖЕНИЯ',
      modalWay2Link: 'Открой ссылку на скачивание с телефона, просканировав QR код',
      step1: 'Шаг 1',
      step2: 'Шаг 2',
      step3: 'Шаг 3',
      step4: 'Шаг 4',
      step5: 'Шаг 5',
      step6: 'Шаг 6',
      step7: 'Шаг 7',
      step8: 'Шаг 8',
      step9: 'Шаг 9',
      step10: 'Шаг 10',
      step11: 'Шаг 11',
      step12: 'Шаг 12',
      step13: 'Шаг 13',
      stepTextAndroid1: 'Нажми кнопку OK \n' +
        'и сохрани .apk файл. ',
      stepTextAndroid2: '\n' +
        'Открой скаченный .apk файл. ',
      stepTextAndroid3: 'После открытия установочного файла, выбери кнопку «Настройки».',
      stepTextAndroid4: 'Отметь пункт «Разрешить установку из этого источника». ',
      stepTextAndroid5: 'В появившемся окне нажми «Установить»',
    },
    sw: {
      title: 'Android - Kuwekeza dau za michezo mtandaoni kwenye Alamisho ZENBET',
      titlePlay: 'Cheza ukiwa popote!',
      subTitle: 'Matukio yote ya michezo kwenye programu moja',
      button: 'PAKUA KWA AJILI YA',
      instruction: 'Maagizo ya kusakinisha',
      contentTitle: 'Upeperushaji wa moja kwa moja wa matukio makuu',
      smartphone: 'Sasa unaweza kutumia simu yako mahiri kuingia',
      navTitle: 'Kutafuta haraka',
      navText: 'Ina kiolesura ambacho ni rahisi kutumia',
      playTitle: 'Weka mkusanyiko kwa kubofya mara chache',
      playText: 'Angalia historia yako ya kuwekeza dau, weka pesa na uwe mshindi!',
      instructionTitle: 'Mwongozo wa usakinishaji wa Android',
      instructionTitleIos: 'Mwongozo wa usakinishaji wa iOS',
      footerLink: ' yuko tayari kukusaidia ',
      footerText1: 'Ikiwa una maswali yoyote kuhusu kusakinisha au kutumia programu hii, ',
      footerText2: ' unaweza kuwasiliana ',
      modalTitle: 'Nitapataje programu ya Android',
      modalTitleIos: 'Nitapataje programu ya iOS',
      modalText: 'Samahani, huduma za Google Play hazipatikani kwa alamisho. Tunaandaa njia tatu za kupakua programu yetu. Unaweza kuisakinisha kwa kufuata ',
      modalTextLink: ' maagizo rahisi.',
      modalWay1: 'Njia ya 1',
      modalWay2: 'Njia ya 2',
      modalWay1Link: 'Pakua programu na uihamishe kwa simu yako au ufungue ukurasa huu kwenye simu yako',
      modalWay1Button: 'PAKUA FAILI',
      modalWay1ButtonSpan: 'PROGRAMU',
      modalWay2Link: 'Fungua kiungo cha kupakua moja kwa moja kwenye simu yako kwa kuchanganua msimbo wa QR',
      stepText0: ' Fungua Mipangilio na ubofye sehemu ya habari zako',
      stepText1: 'Fungua Media na Purchases au iTunes Store na App Store',
      stepText2: ' Bofya Apple ID yako',
      stepText3: 'Chagua Angalia Apple ID',
      stepText4: ' Chagua Nchi/Mkoa',
      stepText5: ' Chagua India',
      stepText6: 'Bofya Kubali au Imefaulu kwenye kona ya juu kulia',
      stepText7: 'Kubali Sheria & Masharti ya Makubaliano na Mtumiaji',
      stepText8: ' Jaza sehemu zinazoonyeshwa kwenye picha (isipokuwa sehemu ya Jina la Kwanza na Jina la Mwisho)',
      stepText9: ' Fungua App Store, tafuta programu ya ZENBET na uisakinishe',
      stepText10First: 'Iwapo kumetokea kasoro, fungua akaunti mpya ',
      stepText10Second: ' na uchague India katika sehemu ya Nchi/Mkoa',
      stepText10Link: ' kwenye tovuti  ',
      stepText11First: ' Rudi kwenye HATUA YA 4 ',
      stepText11Second: ' na uchague Toka',
      stepText12First: ' Ingia kwenye akaunti yako mpya, ',
      stepText12Second: ' enda kwa HATUA YA 9',
      step1: 'HATUA YA 1',
      step2: 'HATUA YA 2',
      step3: 'HATUA YA 3',
      step4: 'HATUA YA 4',
      step5: 'HATUA YA 5',
      step6: 'HATUA YA 6',
      step7: 'HATUA YA 7',
      step8: 'HATUA YA 8',
      step9: 'HATUA YA 9',
      step10: 'HATUA YA 10',
      step11: 'HATUA YA 11',
      step12: 'HATUA YA 12',
      step13: 'HATUA YA 13',
      stepTextAndroid1: ' Bofya OK \n' +
        ' na upakue faili ya APK',
      stepTextAndroid2: 'Fungua faili ya APK iliyosakinishwa',
      stepTextAndroid3: 'Baada ya kufungia faili ya kusakinisha, chagua Mipangilio ',
      stepTextAndroid4: 'Bofya Kichale katika sanduku hili',
      stepTextAndroid5: 'Bofya Sakinisha katika ukurasa uliofunguka',
    },
    tr: {
      title: 'Android - Bookmaker ZENBET çevrimiçi spor bahisleri',
      titlePlay: 'Hareket halindeyken oynayın!',
      subTitle: 'Tüm spor etkinlikleri bir uygulamada',
      button: 'İÇİN İNDİR',
      instruction: 'Yükleme talimatları',
      contentTitle: 'Öne çıkan etkinliklerin canlı yayınları',
      smartphone: 'Artık erişmek için akıllı telefonunuzu kullanabilirsiniz',
      navTitle: 'Hızlı gezinme',
      navText: 'Kullanımı kolay bir arabirim ile',
      playTitle: 'Birkaç tıklama ile bir kombine bahis oynayın',
      playText: 'Bahis geçmişinize bakın, para yatırın ve kazanın!',
      instructionTitle: 'Android için kurulum kılavuzu',
      instructionTitleIos: 'iOS için kurulum kılavuzu',
      footerLink: ' size yardımcı olmaya hazır olacaklardır ',
      footerText1: 'Uygulamayı yükleme veya kullanma ile ilgili herhangi bir sorunuz varsa, ',
      footerText2: ' şurayla iletişime geçebilirsiniz',
      modalTitle: 'Android uygulamasını nasıl alabilirim',
      modalTitleIos: 'iOS uygulamasını nasıl alabilirim',
      modalText: 'Üzgünüz, Google Play hizmetleri bahis şirketleri için kullanılamıyor. Uygulamamızı indirmek için 2 yöntem sunuyoruz. Uygulamayı şu ',
      modalTextLink: ' talimatları kullanarak kurabilirsiniz',
      modalWay1: 'Yöntem  1',
      modalWay2: 'Yöntem  2',
      modalWay1Link: 'Uygulamayı indirin ve cep telefonunuza aktarın veya bu sayfayı telefonunuzdan açın',
      modalWay1Button: 'DOSYAYI İNDİRİN',
      modalWay1ButtonSpan: 'UYGULAMALAR',
      modalWay2Link: 'Kare kodu tarayarak telefonunuzda doğrudan indirme bağlantısını açın',
      stepText0: 'Ayarlar\'a gidin ve profilinize dokunun',
      stepText1: ' Medya ve Satın Alınanlar’a veya iTunes Store ve App Store’a gidin',
      stepText2: ' Apple Kimliğinize dokunun',
      stepText3: 'Apple Kimliğini Görüntüle\'ye tıklayın',
      stepText4: 'Ülke/Bölge seçimi yapın',
      stepText5: 'Hindistan\'ı seçin',
      stepText6: 'Sağ üst köşedeki Kabul Et\'e ya da Bitti\'ye tıklayın',
      stepText7: 'Kullanıcı Sözleşmesinin Hüküm ve Koşullarını Kabul Edin',
      stepText8: ' Alanları, fotoğrafta görüldüğü gibi doldurun (Ad ve Soyadı hariç)',
      stepText9: ' App Store’u açın, ZENBET uygulamasını bulun ve yükleyin',
      stepText10First: ' Bir hata oluştuysa, ',
      stepText10Second: ' yeni bir hesap oluşturun ve Ülke/Bölge alanından Hindistan\'ı seçin.',
      stepText10Link: ' web sitesinde ',
      stepText11First: '4. ADIMA geri dönün ',
      stepText11Second: ' ve Çık\'ı seçin',
      stepText12First: 'Yeni hesabınıza giriş yapın, ',
      stepText12Second: ' 9. ADIMA gidin',
      step1: 'Adım 1',
      step2: 'Adım 2',
      step3: 'Adım 3',
      step4: 'Adım 4',
      step5: 'Adım 5',
      step6: 'Adım 6',
      step7: 'Adım 7',
      step8: 'Adım 8',
      step9: 'Adım 9',
      step10: 'Adım 10',
      step11: 'Adım 11',
      step12: 'Adım 12',
      step13: 'Adım 13',
      stepTextAndroid1: ' Tamam\'a tıklayın \n' +
        ' ve APK dosyasını indirin.',
      stepTextAndroid2: 'İndirilen APK dosyasını açın ',
      stepTextAndroid3: 'Kurulum dosyasını açtıktan sonra Ayarlar\'ı seçin. ',
      stepTextAndroid4: 'Bu kaynak kutusundan İzin ver’i işaretleyin',
      stepTextAndroid5: 'Açılan pencerede Yükle seçeneğine tıklayın',
    },
    uz: {
      title: 'Android - sportga onlayn stavkalar ZENBET BK da',
      titlePlay: 'Istalgan vaqtda va istalgan yerda o‘yna!',
      subTitle: 'Barcha sport hodisalari bitta ilovada',
      button: 'UCHUN YUKLAB OLISH',
      instruction: 'O‘rnatish bo‘yicha yo‘riqnoma',
      contentTitle: 'Top hodisalarning to‘g‘ridan-to‘g‘ri translyatsiyalari',
      smartphone: 'Endi sening smartfoningda',
      navTitle: 'Tezkor navigatsiya',
      navText: 'Hodisalarni aks ettirishning qulay formatlari bilan',
      playTitle: 'Atigi bir nechta klikda ekspresslar to‘pla',
      playText: 'Stavkalar tarixini kuzatib bor, hisobni to‘ldir va yut!',
      instructionTitle: 'Android ga o‘rnatish bo‘yicha yo‘riqnoma',
      instructionTitleIos: 'iOS ga o‘rnatish bo‘yicha yo‘riqnoma',
      footerLink: ' senga bajonidil maslahatlar beradi ',
      footerText1: 'Agar senda ilovani o‘rnatish yoki u bilan ishlash bilan bo‘liq savollar yuzaga kelsa, ',
      footerText2: ' qo‘llab-quvvatlash xizmatimiz',
      modalTitle: 'Android uchun ilova qanday olinadi',
      modalTitleIos: 'iOS uchun ilova qanday olinadi',
      modalText: 'Afsuski, Google Play xizmatlaridan bukmekerlar uchun foydalanib bo‘lmaydi, shuning uchun ham biz uchta usuldan istalgani orqali ilovamizni yuklab olishingni va oddiy yo‘riqnomaga ',
      modalTextLink: ' amal qilgan holda uni o‘rnatishingni taklif qilamiz.',
      modalWay1: '1-usul',
      modalWay2: '2-usul',
      modalWay1Link: 'Ilovani yuklab ol va uni o‘z telefoningga ber yoki telefondan shu sahifani och',
      modalWay1Button: 'FAYLNI YUKLAB OLISH',
      modalWay1ButtonSpan: 'ILOVALAR',
      modalWay2Link: 'Telefonda QR kodni skanerlagan holda yuklab olish havolasini och',
      stepText0: ' Sozlamalarga o‘t va profilingizga bos',
      stepText1: '“Mediamateriallar va xaridlar” yoki “iTunes Store va App Store” bandiga o‘t',
      stepText2: ' O‘z Apple ID ga bos',
      stepText3: ' “Apple ID ni ko‘rish” ga o‘t',
      stepText4: ' "Mamlakat yoki mintaqa" bandiga o‘t',
      stepText5: '"Hindiston" ni tanla',
      stepText6: ' Yuqori o‘ngdagi "Qabul qilish" yoki "Tayyor" tugmasini bos',
      stepText7: ' Foydalanuvchi bilan kelishuv shartlarini qabul qil',
      stepText8: ' Maydonlarni fotosuratda ko‘rsatilgani kabi to‘ldir (ism va familiyadan tashqari)',
      stepText9: ' App Store ilovasini och, ZENBET ni top va uni o‘rnat',
      stepText10First: ' Agar xatolik olinsa, ',
      stepText10Second: ' yangi akkaunt yaratish zarur, mamlakat sifatida Hindistonni ko‘rsat',
      stepText10Link: ' saytda  ',
      stepText11First: ' 4-qadamga qayt va ',
      stepText11Second: ' "Chiqish" tugmasini bos',
      stepText12First: ' Yangi akkaunt bilan kir, ',
      stepText12Second: ' 9-qadamga o‘t',
      step1: '1-QADAM',
      step2: '2-QADAM',
      step3: '3-QADAM',
      step4: '4-QADAM',
      step5: '5-QADAM',
      step6: '6-QADAM',
      step7: '7-QADAM',
      step8: '8-QADAM',
      step9: '9-QADAM',
      step10: '10-QADAM',
      step11: '11-QADAM',
      step12: '12-QADAM',
      step13: '13-QADAM',
      stepTextAndroid1: ' OK tugmasini bos \n' +
        ' va .apk faylini saqla.',
      stepTextAndroid2: 'Yuklab olingan .apk faylni och ',
      stepTextAndroid3: 'O‘rnatish faylini ochgandan keyin "Sozlamalar" tugmasini bos. ',
      stepTextAndroid4: '"Shu manbadan o‘rnatishga ruxsat berish" bandini belgila.',
      stepTextAndroid5: 'Paydo bo‘lgan oymada "O‘rnatish" tugmasini bos',
    },
    vi: {
      title: 'Android - Nhà cái cá cược thể thao trực tuyến ZENBET',
      titlePlay: 'Chơi khi đang di chuyển!',
      subTitle: 'Tất cả các sự kiện thể thao trong một ứng dụng',
      button: 'TẢI XUỐNG CHO THIẾT BỊ',
      instruction: 'Hướng dẫn cài đặt',
      contentTitle: 'Phát trực tiếp các sự kiện hàng đầu',
      smartphone: 'Bây giờ bạn có thể sử dụng điện thoại thông minh của mình để truy cập',
      navTitle: 'Điều hướng nhanh chóng',
      navText: 'Với giao diện dễ sử dụng',
      playTitle: 'Đặt một bộ tích lũy trong một vài cú nhấp chuột',
      playText: 'Kiểm tra lịch sử cá cược của bạn, nạp tiền và giành chiến thắng!',
      instructionTitle: 'Hướng dẫn cài đặt cho thiết bị Android',
      instructionTitleIos: 'Hướng dẫn cài đặt cho thiết bị iOS',
      footerLink: ' sẵn sàng trợ giúp bạn ',
      footerText1: 'Nếu bạn có bất kỳ câu hỏi nào về việc cài đặt hoặc sử dụng ứng dụng, ',
      footerText2: ' bạn có thể liên hệ',
      modalTitle: 'Cách tải ứng dụng dành cho thiết bị Android',
      modalTitleIos: 'Cách tải ứng dụng dành cho thiết bị iOS',
      modalText: 'Rất tiếc, các dịch vụ của Google Play không có sẵn cho các nhà cái. Chúng tôi cung cấp 3 phương pháp để tải xuống ứng dụng của chúng tôi. Bạn có thể cài đặt bằng cách làm theo ',
      modalTextLink: ' các hướng dẫn đơn giản.',
      modalWay1: 'Phương pháp 1',
      modalWay2: 'Phương pháp 2',
      modalWay1Link: 'Tải xuống ứng dụng và chuyển sang điện thoại di động hoặc mở trang này từ điện thoại của bạn',
      modalWay1Button: 'TẢI XUỐNG TỆP',
      modalWay1ButtonSpan: 'ỨNG DỤNG',
      modalWay2Link: 'Mở liên kết tải xuống trực tiếp trên điện thoại của bạn bằng cách quét mã QR',
      stepText0: 'Đi đến cài đặt và nhấn vào hồ sơ của bạn',
      stepText1: ' Đi đến Phương tiện và Giao dịch mua hoặc tới iTunes Store và App Store',
      stepText2: 'Nhấn vào ID Apple của bạn',
      stepText3: ' Chọn xem Apple ID',
      stepText4: 'Chọn quốc gia/vùng',
      stepText5: ' Chọn Ấn Độ',
      stepText6: 'Nhấn vào Chấp nhận hoặc Hoàn tất ở góc trên cùng bên phải',
      stepText7: 'Chấp nhận các Điều khoản & Điều kiện của Thỏa thuận Người dùng',
      stepText8: 'Điền vào các trường như trong ảnh (ngoại trừ Tên và Họ)',
      stepText9: ' Mở App Store, tìm ứng dụng ZENBET và cài đặt',
      stepText10First: 'Nếu xảy ra lỗi, hãy tạo một tài khoản mới trên ',
      stepText10Second: ' và chọn Ấn Độ trong trường Quốc gia/Vùng',
      stepText10Link: '  trang web  ',
      stepText11First: 'Quay lại BƯỚC 4 ',
      stepText11Second: ' và chọn Thoát',
      stepText12First: ' Đăng nhập vào tài khoản mới của bạn, ',
      stepText12Second: ' chuyển sang BƯỚC 9',
      step1: 'Bước 1',
      step2: 'Bước 2',
      step3: 'Bước 3',
      step4: 'Bước 4',
      step5: 'Bước 5',
      step6: 'Bước 6',
      step7: 'Bước 7',
      step8: 'Bước 8',
      step9: 'Bước 9',
      step10: 'Bước 10',
      step11: 'Bước 11',
      step12: 'Bước 12',
      step13: 'Bước 13',
      stepTextAndroid1: 'Nhấn OK \n' +
        ' và tải xuống tệp APK ',
      stepTextAndroid2: 'Mở tệp APK đã tải xuống. ',
      stepTextAndroid3: 'Sau khi mở tệp cài đặt, hãy chọn Cài đặt ',
      stepTextAndroid4: 'Chọn hộp Cho phép từ nguồn này',
      stepTextAndroid5: 'Nhấp vào Cài đặt trong cửa sổ đã mở',
    },
  },
}